<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img class="pointer" @click="clickLocalStep()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <!-- 开卡礼包规则 -->
        <div class="card-point" v-if="activityData.id == 13">
          <div class="card-rule">官方规则：</div>
          <div class="card-connet">
            <p>1、<span class="orangeColor">活动生效时间：</span> POP和自营15分钟后生效。</p>
            <p>2、礼包涉及到引导用户跳转至新页面开卡，因此礼包无法直接完成发奖，您可以将奖励配置到用户跳转的目标页面。</p>
            <p>3、淘宝规定店铺礼包奖品不可为空，为保证礼包创建成功，此处为礼包默认创建<span class="orangeColor">1积分</span>为奖品。</p>
          </div>
        </div>
        <!-- 店铺礼包 -->
        <div class="card-point" v-if="activityData.id == 14">
          <div class="card-rule">官方规则：</div>
          <div class="card-connet">
            <p>1、<span style="color:#000;font-weight: bold;">活动生效时间：</span>POP和自营15分钟后生效。</p>
            <p>2、FCS商家创建礼包时，暂时无法选择优惠券礼品，请您知晓，避免造成客诉！</p>
          </div>
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="140px">
          <template v-if="activityData.id != 13 && activityData.id != 14">
            <el-form-item label="活动名称:" required>
              <!-- prop="activityName" 活动名称 -->
              <el-input v-model="ruleForm.activityName" maxlength="50" show-word-limit placeholder="积分任务的展示名称" style="width: 340px"></el-input>
            </el-form-item>
            <el-form-item label="活动时间:" required>
              <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
              <div class="my_select_time">
                <el-date-picker
                  v-model="activityTimeValue"
                  type="datetimerange"
                  class="rangeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  ref="timeBox"
                  @change="activityTimeChange"
                  style="width: 340px; font-size: 12px"
                  :picker-options="pickerOptionsValue"
                  :default-time="defaultTime"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天 <span style="color: #2670fb">{{ timeOut }}</span> 小时
                <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>
          </template>
          <el-form-item label="活动对象:" required>
          <el-radio-group v-model="ruleForm.activityObject" :disabled="isStartEdit" @change="handleActivityObj">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">指定身份</el-radio>
            <el-radio :label="2" disabled>指定人群</el-radio>
          </el-radio-group>
          <span class="margin-left-12">
            <el-popover
              placement="right-start"
              trigger="hover"
              content="您不满足使用该功能的条件，请联系专属客服了解~">
              <el-button slot="reference" disabled>{{ selectCrowdText }}</el-button>
            </el-popover>
          </span>
        </el-form-item>
        <el-form-item
          label="新老客户:"
          required
          v-if="ruleForm.activityObject === 1"
        >
          <el-radio-group v-model="ruleForm.newOldCustomer" :disabled="isStartEdit">
            <el-radio :label="0">不限</el-radio>
            <el-radio :label="1">新客</el-radio>
            <el-radio :label="2">老客</el-radio>
          </el-radio-group>
          <span class="margin-left-12">
            <span class="tips-style margin-left-12">新老客说明</span>
            <el-tooltip class="item" effect="light" placement="bottom">
              <span slot="content">
                <div>历史订单中已完成订单的订单数为0则定义为新客</div>
                <div>历史订单中已完成订单的订单数≥1则定义为老客</div>
              </span>
              <i class="el-icon-question margin-left-8"></i>
            </el-tooltip>
          </span>
        </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            :disabled="isStartEdit"
            v-if="(localStepNum == 1 || localStepNum == 2 || localStepNum == 3 || localStepNum == 4 || localStepNum == 6)&&ruleForm.activityObject == '1'"
          >
            <el-checkbox-group v-model="ruleForm.partner" @change="checkListchange" :disabled="isStartEdit">
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox label="0" name="partner" :disabled="ruleForm.partner == -1">非会员</el-checkbox>

              <el-checkbox v-for="(item, index) in levelList" :key="index" :label="index + 1 + ''" name="partner" :disabled="ruleForm.partner == -1">{{
                item
              }}</el-checkbox>
            </el-checkbox-group>
            <span class="warningTitele" v-if="localStepNum == 3">
              <i class="el-alert__icon el-icon-info" style="color:#EBAA3C"></i>
              注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次
            </span>
          </el-form-item>
          <el-form-item
            label="入会时间:"
            v-if="(localStepNum == 1 ||
              localStepNum == 3 ||
              localStepNum == 4 ||
              localStepNum == 6 ||
              localStepNum == 7) && ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="isEditOrDraft"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

        <el-form-item v-if="localStepNum == 6" label="活动互斥:" prop="exclusion">
          <div style="display: flex;align-items: center;height: 32px;font-size: 12px;">
          <el-switch v-model="ruleForm.exclusion" style="margin-right: 8px;">
          </el-switch>
          <span>
            开启后，若用户已经参与过生日登记有礼、完善信息有礼活动，则在本次活动中自动关联历史活动登记的用户信息（包含已填写过的用户资料与生日时间），无需用户二次填写
          </span>
          </div>
        </el-form-item>

          <el-form-item label="奖品设置:" prop="prizeSite" v-if="localStepNum == 3 || localStepNum == 6">
            赠送
            <el-input  @blur="beAdd(ruleForm.bonusPoints,'bonusPoints')" v-model="ruleForm.bonusPoints" placeholder="请输入" style="width: 70px" @input="ruleForm.bonusPoints = getNumberData($event, 0, 0)"> </el-input>
            积分
          </el-form-item>

          <el-form-item label="完善资料信息:" prop="information" v-if="localStepNum == 6">
            <!-- 上部分 -->
            <el-checkbox-group  v-model="ruleForm.information" @change="handleDischange" :disabled="isStartEdit">
              <el-checkbox label="-1" name="partner" :disabled="disItem == 1">全部</el-checkbox>
              <el-checkbox label="姓名" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="手机号码" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="生日" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="微信" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="QQ" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="邮箱" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="性别" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="职业" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="地区" name="partner" :disabled="disItem == 2"></el-checkbox>
              <el-checkbox label="详细地址" name="partner" :disabled="disItem == 2"></el-checkbox>
              <br />
            </el-checkbox-group>
            <!-- 下部分 -->
            <el-checkbox-group  v-model="ruleForm.informationOne" style="margin:10px 0;" :disabled="isStartEdit">
              <div v-for="(item, index) in itemArrOne.slice(0, 10)" :key="index" style="margin-bottom:10px;">
                <el-checkbox
                :label="index"
                :key="index"
                @change="handleChangeSelected($event,item,index)"
                >
                  <el-select v-model="item.informationmationSelect" placeholder="请选择" style="width: 100px;margin-right: 12px;" @change="handleSelect($event,index)">
                    <el-option
                      v-for="msg in msgOptions"
                      :key="msg.value"
                      :label="msg.label"
                      :value="msg.value">
                    </el-option>
                  </el-select>
                  <el-input :disabled="isStartEdit" v-model="item.informationmationOne" placeholder="自定义信息名称"> </el-input>
                  <el-button :disabled="isStartEdit" style="color:#F56C6C;text-align: left;" type="text" @click="deleteaInfo(index)">
                    删除
                  </el-button>
                </el-checkbox>
              </div>
            </el-checkbox-group>
            <div class="addBox pointer" v-if="itemArrOne.length < 10" @click="perfectAdd">添加  （{{ itemArrOne.length ? itemArrOne.length : 0 }}/10）</div>
            <div class="addBox pointer" v-else>添加  （{{ itemArrOne.length ? itemArrOne.length : 0 }}/10）</div>
          </el-form-item>

          <el-form-item label="隐私政策设置:" prop="privacySelected" v-if="localStepNum == 6">
            <el-checkbox v-model="ruleForm.privacySelected" style="margin-bottom: 10px;" :disabled="isStartEdit">设置隐私政策</el-checkbox>
            <el-form-item label="标题:" required label-width="84px">
              <el-input  :disabled="isStartEdit" v-model="ruleForm.improveInformationPrivacyDTO.privacyTitle" maxlength="10" show-word-limit placeholder="隐私政策" style="width: 340px"></el-input>
            </el-form-item>
            <el-form-item label="勾选条件:" required label-width="84px">
              <el-checkbox :disabled="isStartEdit" v-model="ruleForm.improveInformationPrivacyDTO.isNecessary">用户勾选才可提交填写的信息</el-checkbox>
              <span class="privacyWarningTitele">
                <i class="el-alert__icon el-icon-info" style="color:#EBAA3C"></i>
                注：勾选后，用户填写信息提交前，需选择勾选已阅读当前隐私政策，才可提交信息
              </span>
            </el-form-item>
            <el-form-item label="内容:" required label-width="84px">
              <div class="privacyContent">
                <el-input
                  type="textarea"
                  class="textarea"
                  style="width: 484px;"
                  resize="none"
                  v-model="ruleForm.improveInformationPrivacyDTO.privacyDescription"
                  :disabled="isStartEdit || backgroundOpacity"
                  :maxlength="8000"
                ></el-input>
                <div class="prosi" style="color: #909399">
                  （{{ ruleForm.improveInformationPrivacyDTO.privacyDescription.length ? ruleForm.improveInformationPrivacyDTO.privacyDescription.length: 0 }}/8000）
                </div>
              </div>
            </el-form-item>
          </el-form-item>

          <el-form-item label="活动条件:" v-if="localStepNum == 1 || localStepNum == 2">
            <el-checkbox label="关注店铺后方可参与活动" v-model="ruleForm.isFollow" :disabled="isStartEdit"></el-checkbox>
          </el-form-item>

          <el-form-item label="每日开抢时间:" prop="startTime" v-if="localStepNum == 2">
            <el-time-picker :disabled="isStartEdit" v-model="ruleForm.startTime" placeholder="请选择时间" value-format="HH:mm:ss" class="startTime"> </el-time-picker>
          </el-form-item>

          <el-form-item label="过滤规则:" v-if="this.activityData.name=='邀请关注店铺有礼'">
            <div style="display: flex;align-items: center;height: 32px">
            <el-radio-group v-model="filterInviteOption">
              <el-radio :label="0">过滤同一活动中被邀请过的人</el-radio>
              <el-radio :label="1">过滤所有活动中被邀请过的人</el-radio>
            </el-radio-group>
            <el-popover
            placement="top-start"
            trigger="hover"
            width="400"
            >
              <div>
                <div>被邀请人过滤规则：</div>
                <div>1.过滤同一活动中被邀请过的人：即表示同一个人在同一个活动中仅能被有效邀请1次</div>
                <div>2.过滤所有活动中被邀请过的人：即表示同一个人在所有活动中仅能被有效邀请1次</div>
              </div>
              <i slot="reference" style="color: #ccc;margin-left: 10px;" class="el-icon-question"></i>
              </el-popover>
              </div>
          </el-form-item>

          <!-- <el-form-item label="有效规则:" prop="test">
            <div style="display: flex;align-items: center;height: 32px">
            <el-radio-group v-model="radio2">
              <el-radio :label="0">被邀请人成功入会</el-radio>
              <el-radio :label="1">被邀请人成功入会且达到指定等级</el-radio>
            </el-radio-group>
            <el-checkbox-group style="margin-left: 20px;" v-model="checkbox1" v-if="radio2 == 1">
              <el-checkbox v-for="(item,index) in levelList" :label="item" :key="levelList"></el-checkbox>
            </el-checkbox-group>
            </div>
          </el-form-item> -->

          <el-form-item label="选择奖品:" prop="choosePrize" v-if="localStepNum == 2">
            <el-button @click="centerVis" :disabled="isStartEdit">选择奖品</el-button>
            <div class="theLag" v-if="prizeSettingList.prizeType">
              <div class="theBox">
                <p style="margin: 30px 0 25px 0; padding-left: 25px; width: 280px; text-align: center; text-overflow: -o-ellipsis-lastline; overflow: hidden; text-overflow: ellipsis;display: -webkit-box; -webkit-line-clamp: 1; line-clamp: 1; -webkit-box-orient: vertical;">
                  {{ prizeSettingList.title }}
                </p>
                <p class="pp" v-if="prizeSettingList.prizeType == 1">优惠券</p>
                <p class="pp" v-if="prizeSettingList.prizeType == 2">京豆</p>
                <p class="pp" v-if="prizeSettingList.prizeType == 3">实物</p>
                <p class="pp" v-if="prizeSettingList.prizeType == 4">店铺积分</p>
                <p class="pp" v-if="prizeSettingList.prizeType == 5">淘宝E卡</p>
                <p class="pp" v-if="prizeSettingList.prizeType == 6">
                  爱奇艺会员
                </p>
                <p class="pp" v-if="prizeSettingList.prizeType == 7">
                  京豆PLUS会员
                </p>
                <p class="pp" v-if="prizeSettingList.prizeType == 8">现金红包</p>
                <p class="pp" v-if="prizeSettingList.prizeType == 9">谢谢参与</p>
                <p class="pp" v-if="prizeSettingList.prizeType == 10">专属商品</p>
              </div>
              <div class="backgrd"></div>
              <el-button class="btnQx" type="primary" @click="deleteCoupon" :disabled="isStartEdit">删除</el-button>
            </div>
          </el-form-item>
          <el-form-item label="奖品设置:" prop="setPrize" v-if="localStepNum == 4 || localStepNum == 5">
            <el-radio v-model="ruleForm.isCumulativePrize" :label="false" :disabled="isStartEdit">统一奖品</el-radio>
            <el-radio v-model="ruleForm.isCumulativePrize" :label="true"  :disabled="isStartEdit">梯度奖品</el-radio>
            <div class="prize_box">
              <template v-if="!ruleForm.isCumulativePrize">
                <div>
                  <span>奖品库存显示：</span>
                  <el-radio :disabled="isStartEdit" v-model="isShowRemanentAmount" :label="0">不显示</el-radio>
                  <el-radio :disabled="isStartEdit" v-model="isShowRemanentAmount" :label="1">显示</el-radio>
                  <el-popover placement="top-start" trigger="hover" width="450">
                    <div>
                      <div>选中“显示”，则活动用户可在活动页面中查看奖品的剩余库存。</div>
                    </div>
                    <i slot="reference" style="color: #ccc;margin-left: 10px;" class="el-icon-question"></i>
                  </el-popover>
                </div>
                <div style="margin-bottom:10px" class="line">
                  <div>每邀请一人可得</div>
                  <div v-if="prizeSettingList.prizeType != 3 && prizeSettingList.prizeType != 1 && prizeSettingList.prizeType != 10" style="color:#FE4D45;margin:0 10px;">
                    {{ prizeSettingList.prizeTxt }}<span v-if="prizeSettingList.prizeType==1">元</span>{{ prizeSettingList.prizeType | prizeType }}
                  </div>
                  <div v-else-if="prizeSettingList.prizeType != 3 && prizeSettingList.prizeType == 1" style="color:#FE4D45;margin:0 10px;">
                    {{ prizeSettingList.price }}元优惠券
                  </div>
                  <div v-else style="color:#FE4D45;margin:0 10px">{{ prizeSettingList.title }}</div>
                  <div>，超出人数不再获得奖励</div>
                  <el-tooltip class="item" effect="light" content="以成功邀请好友关注店铺的人数为准" placement="bottom">
                    <el-button type="text" style="width: 40px;">
                      <i style="color: #ccc;" class="el-icon-question"></i>
                    </el-button>
                  </el-tooltip>
                </div>
                <div style="margin-bottom:20px" class="line">
                  <div>奖品总份数：</div>
                  <el-input v-model="ruleForm.prizeCount" @input="ruleForm.prizeCount = getNumberData($event, 0)" style="width: 70px;margin:0 10px"></el-input>
                  <div>份</div>
                </div>
                <el-button @click="centerVis">选择奖品</el-button>
                <div class="theLag" v-if="prizeSettingList.prizeType">
                  <div class="theBox">
                    <div v-if="prizeSettingList.prizeType != 3 && prizeSettingList.prizeType != 1 && prizeSettingList.prizeType != 10" class="flex" style="margin: 30px 0 15px 0; width: 280px;justify-content: center;">
                      <div class="discount_sty">{{ prizeSettingList.prizeTxt?prizeSettingList.prizeTxt:prizeSettingList.price }}<span v-if="prizeSettingList.prizeType==1">元</span></div>
                      <div style="height:44px; width:1px;background:#FE4D45;opacity: .2;margin:0 12px"></div>
                      <div style="color:#999999">{{ prizeSettingList.prizeType | prizeType }}</div>
                    </div>
                    <div v-else-if="prizeSettingList.prizeType != 3 && prizeSettingList.prizeType == 1" class="flex" style="margin: 30px 0 15px 0; width: 280px;justify-content: center;">
                      <div class="discount_sty">{{ prizeSettingList.price }}<span v-if="prizeSettingList.prizeType==1">元</span></div>
                      <div style="height:44px; width:1px;background:#FE4D45;opacity: .2;margin:0 12px"></div>
                      <div style="color:#999999">{{ prizeSettingList.prizeType | prizeType }}</div>
                    </div>
                    <p v-else style="margin: 30px 0 25px 0; padding-left: 25px; width: 280px; text-align: center; text-overflow: -o-ellipsis-lastline; overflow: hidden; text-overflow: ellipsis;display: -webkit-box; -webkit-line-clamp: 1; line-clamp: 1; -webkit-box-orient: vertical;">
                      {{ prizeSettingList.title }}
                    </p>
                    <p class="pp">{{ prizeSettingList.prizeType | prizeType }}</p>
                  </div>
                  <div class="backgrd"></div>
                  <el-button class="btnQx" type="primary" @click="deleteCoupon" :disabled="isStartEdit">删除</el-button>
                </div>
              </template>
              <template v-else>
                <div class="tips">
                  <img
                    src="@/assets/images/new_icon_waring_yellow.png"
                    style="
                        margin-right:6px;
                        position: relative;
                        width: 14px;
                        height: 14px;
                        color: #FFB95E;
                      "
                  />
                  <span>温馨提示</span>
                  <p>
                    规则：达到邀请人数的最大人数并领取奖品后，可继续邀请开卡但是不能获得奖品
                  </p>
                </div>
                <div>
                  <span>奖品库存显示：</span>
                  <el-radio :disabled="isStartEdit" v-model="isShowRemanentAmount" :label="0">不显示</el-radio>
                  <el-radio :disabled="isStartEdit" v-model="isShowRemanentAmount" :label="1">显示</el-radio>
                  <el-popover placement="top-start" trigger="hover" width="450">
                    <div>
                      <div>选中“显示”，则活动用户可在活动页面中查看奖品的剩余库存。</div>
                    </div>
                    <i slot="reference" style="color: #ccc;margin-left: 10px;" class="el-icon-question"></i>
                  </el-popover>
                </div>
                <el-table
                  :header-cell-style="{ 'text-align': 'center', 'border-bottom': '2px solid #EBEEF5' }"
                  :cell-style="{ 'text-align': 'center' }"
                  :data="tableData"
                  border
                  style="width: 520px"
                >
                  <el-table-column prop="date" label="邀请人数" width="110">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.peopleCount" @input="scope.row.peopleCount = getNumberData($event, 0)"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="奖品类型">
                    <template slot-scope="scope">
                      <span style="color:#7F85E9;cursor: pointer;" v-if="scope.row.prizeType == 3 || scope.row.prizeType == 10" @click="centerVis(scope)">{{
                        scope.row.title
                      }}</span>
                      <span style="color:#7F85E9;cursor: pointer;" v-else-if="scope.row.prizeType" @click="centerVis(scope)">{{
                        scope.row.prizeType | prizeType
                      }}</span>
                      <span v-else @click="centerVis(scope)" style="color:#FE4D45;cursor: pointer;">选择奖品</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" width="110" label="值"> </el-table-column>
                  <el-table-column prop="address" width="145" label="奖品总份数">
                    <template slot-scope="scope">
                      <el-input 
                      @blur="beAdd(scope.row,2)"
                      v-model="scope.row.prizeCount" 
                      @input="scope.row.prizeCount = getNumberData($event, 0)"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
                <div @click="addPrizeRule" class="add_btn">
                  <!-- <img style="width:24px" src="../../assets/images/btn_添加.svg" alt="" /> -->
                  添加条件
                </div>
              </template>
            </div>
          </el-form-item>

          <el-form-item label="奖品份数:" prop="prizeCount" v-if="localStepNum == 2">
            每日共赠送
            <el-input @blur="beAdd(ruleForm.prizeCount,'prizeCount')" v-model="ruleForm.prizeCount" placeholder="请输入" @input="ruleForm.prizeCount = getNumberData($event, 0)" style="width: 70px"> </el-input>
            份奖品，每人每日限领一份奖品，先到先得
          </el-form-item>

          <!-- 签到赢好礼 -->
        <div class="newsInfo" v-if="activityData.id == 1">签到设置</div>
        <el-form-item label="每日签到奖品设置:" prop="prizeSet" v-if="activityData.id == 1" required>
          <el-checkbox-group v-model="ruleForm.prizeSet" :disabled="isStartEdit">
            <el-checkbox name="prizeSet" @change="prizeSetChange">
              每日签到送
              <span style="color:#2670FB">{{awardSettingsLsit[0].title}}</span>
            </el-checkbox>
            <br />
          </el-checkbox-group>
          <el-table
            :data="awardSettingsLsit"
            style="width: 1100px; border: 1px solid #f0f0f0;margin-top: 15px;"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
          >
            <el-table-column label="选择奖品">
              <template slot-scope="scope">
                <span class="s" style="color:#2670FB;cursor: pointer;" @click="centerVis(scope)">选择奖品</span>
              </template>
            </el-table-column>

            <el-table-column label="奖品类型">
              <template slot-scope="scope">
                <span>{{ scope.row.prizeType | prizeType }}</span>
              </template>
            </el-table-column>
            <el-table-column label="值" width="80" prop="price"></el-table-column>
            <el-table-column label="奖品名称（12字内）" width="299">
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.title"
                  maxlength="12"
                  :disabled="scope.row.prizeType != 3 || limit || isStartEdit"
                  show-word-limit
                  style="width: 240px"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="奖品数量" width="200">
              <template slot-scope="scope">
                <el-input
                  @blur="beAdd(scope.row,1)"
                  v-model="scope.row.totalAmount"
                  @input="scope.row.totalAmount = getNumberData($event, 0)"
                  maxlength="10"
                  class="inputcount"
                  show-word-limit
                  style="width: 150px"
                  placeholder="请输入"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="连续签到奖品设置:" v-if="activityData.id == 1">
          <el-checkbox-group v-model="ruleForm.prizeSetOne" :disabled="isStartEdit">
            <el-checkbox label="连续签到" name="prizeSet" @change="signInpoints">连续签到送 &nbsp;</el-checkbox>
          </el-checkbox-group>
          <div class="ruloBox">
            <span class="desc">
                <i class="el-alert__icon el-icon-info" style="color:#2670FB"></i>
            </span>
            <span style="padding: 12px 0 0 7px;">规则：达到连续签到最大天数并领取奖品后，签到记录清零，从第1天重新计算。</span></br>
            <span style="padding: 0 0 12px 22px;">
              例如：连续签到规则最大天数为5天，则连续签到5天并领取奖品后，第6天的连续签到记录是1天，多条件为累计叠加。
            </span>
          </div>
          <el-table
            :data="itemArr"
            style="width: 1100px; border: 1px solid #f0f0f0;margin-top: 15px;"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            v-if="ruleForm.prizeSetOne"
          >
            <el-table-column label="连续签到天数" width="150">
              <template slot-scope="scope">
                <el-input
                 :disabled="isStartEdit"
                  v-model="scope.row.days"
                  @input="scope.row.days = getNumberData($event, 0)"
                  style="width: 140px"
                  placeholder="请输入"
                ></el-input>
              </template>
              </el-table-column>
              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" style="color:#2670FB;cursor: pointer;" @click="centerVis1(scope)">选择奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span>{{ scope.row.prizeType | prizeType }}</span>
                </template>
              </el-table-column>
              <el-table-column label="值" width="80" prop="price"></el-table-column>
              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    maxlength="12"
                    :disabled="scope.row.prizeType != 3 || isStartEdit"
                    show-word-limit
                    style="width: 240px"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="奖品数量" width="200">
                <template slot-scope="scope">
                  <el-input
                    @blur="beAdd(scope.row,1)"
                    v-model="scope.row.totalAmount"
                    @input="scope.row.totalAmount = getNumberData($event, 0)"
                    maxlength="10"
                    class="inputcount"
                    show-word-limit
                    style="width: 150px"
                    placeholder="请输入"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span style="color:red;" v-show="scope.$index != 0" class="pointer" @click="deletea(scope.$index)">删除</span>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" class="generate"   :disabled="isStartEdit" plain @click="addCondition" v-if="ruleForm.prizeSetOne">增加奖项</el-button>
          </el-form-item>
          
          <el-form-item
            label="曝光商品:"
            prop="exposure"
            class="zindexBox"
            v-if="localStepNum == 1 || localStepNum == 2 || localStepNum == 3 || localStepNum == 4 || localStepNum == 5"
          >
            <el-checkbox v-model="ruleForm.exposureSwitch">
              是否添加曝光商品
            </el-checkbox>
            <el-button style="width: 155px; margin: 0 15px" @click="exposureProducts" :disabled="ruleForm.exposureSwitch == false">
              {{ itemListFor.length != "" ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")" : "添加曝光商品" }}
            </el-button>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px 10px 0px 10px;"
            >
              <transition-group type="transition">
                <div v-for="(item, index) in mainImagelist" :key="item.skuId" style="display: inline-block; position: relative" class="show_upImg2">
                  <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img src="@/assets/thdImg/pages/delet.svg" @click.stop="delec(item,index)" class="delectIcom" />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>

          <!-- 开卡礼包和店铺 -->
          <template v-if="activityData.id == 13 || activityData.id == 14">
            <el-form-item label="活动名称:" required>
              <!-- prop="activityName" 活动名称 -->
              <el-input v-model="ruleForm.activityName" maxlength="50" show-word-limit placeholder="请填入活动名称" style="width: 340px"></el-input>
            </el-form-item>

            <el-form-item label="活动时间:" required>
              <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
              <div class="my_select_time">
                <el-date-picker
                  v-model="activityTimeValue"
                  type="datetimerange"
                  class="rangeTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  ref="timeBox"
                  @change="activityTimeChange"
                  style="width: 340px; font-size: 12px"
                  :picker-options="pickerOptionsValue"
                  :default-time="defaultTime"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
              </div>
              <span class="lastTime" style="color: #666">
                活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天 <span style="color: #2670fb">{{ timeOut }}</span> 小时
                <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                  <el-button type="text" style="width: 35px;">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </span>
            </el-form-item>
            <el-form-item label="关注店铺:">
              <el-radio v-model="ruleForm.requestFollow" label="1">是</el-radio>
              <el-radio v-model="ruleForm.requestFollow" label="2">否</el-radio>
              <el-tooltip class="item" effect="light" content="勾选关注后参加活动的同时关注店铺" placement="bottom">
                <el-button type="text" style="margin-left: -20px;width:35px">
                  <i class="el-icon-question" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
            </el-form-item>

            <el-form-item label="加购商品:" class="zindexBox" prop="exposure" v-if="activityData.id == 14">
              <el-radio-group @change="exposureChange" v-model="ruleForm.radio">
                <el-radio :label="0">不限制</el-radio>
                <el-radio :label="1">加购商品</el-radio>
              </el-radio-group>
              <el-button :style="{width: itemListFor.length > 0 ? '110px':'60px', margin:' 0 0px 0 15px'}" @click="exposureProducts" :disabled="ruleForm.exposureSwitch == false">
                {{ itemListFor.length != "" ? "+添加" + "(" + itemListFor.length + "/20" + ")" : "+添加" }}
              </el-button>
              <el-tooltip class="item" effect="light" content="勾选后领取礼包直接加购指定商品，最多添加20个sku" placement="bottom">
                <el-button type="text" style="width:35px">
                  <i class="el-icon-question" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
              <draggable
                v-if="itemListFor.length > 0"
                v-model="mainImagelist"
                chosen-class="chosen"
                :scroll="true"
                animation="150"
                force-fallback="true"
                @start="isDragging = true"
                @end="onEnd"
                style="margin-top: 10px;"
              >
                <transition-group type="transition" style="background: rgba(38,112,251,0.06);padding: 10px;">
                  <div v-for="(item, index) in mainImagelist" :key="item.skuId" style="display: inline-block; position: relative" class="show_upImg2">
                    <img :src="item.logo" width="120px" height="120px" style="display: inline-block" />&nbsp;
                    <div class="delectPosible">
                      <span class="delectSort">拖动排序</span>
                      <img src="@/assets/thdImg/pages/delet.svg" @click.stop="delec(item, index)" class="delectIcom" />
                    </div>
                  </div>
                </transition-group>
              </draggable>
            </el-form-item>
            <el-form-item label="选择目标人群:" required>请选择需要投放的人群 </el-form-item>
            <div class="crowd">
              <div class="crowd-point">
                <span style="color:#000">系统自定义人群</span>
              </div>
              <div style="border: 1px solid #f0f0f0;">
                <div class="crowd-tab">
                  <div class="crowd-tab-head">
                    <div class="crowd-tab-name">人群名称</div>
                    <div class="crowd-tab-sm"  style="color:#000">人群说明</div>
                  </div>
                  <div class="crowd-tab-middle" v-for="item in personLab.customizeList" :key="item.labelId">
                    <div class="crowd-tab-name nameAlign">
                      <el-radio style="width:97%" @change="radioChange" v-model="ruleForm.modelIds" :label="item.labelId">
                        <el-tooltip  class="item" effect="light" :content="item.labelName" placement="top-start">
                          <el-button class="overHiddle">{{ item.labelName }}</el-button>
                        </el-tooltip>
                      </el-radio>
                    </div>

                    <div class="crowd-tab-sm" :class="{ descbox: item.labelVal }">
                      {{ item.labelDesc }}
                      <template v-if="!disableVF">
                        <div class="dx" v-if="item.labelVal && item.labelVal.length > 1">
                          <el-checkbox :disabled="disableVF" style="display: inline-block" v-model="verCheckAll" @change="handleCheckedChange"
                            >全选</el-checkbox
                          >
                          <el-checkbox-group @change="handleChang" style="display: inline-block;margin-left: 30px;" v-model="ruleForm.vermicelliVal">
                            <el-checkbox :disabled="disableVF" v-for="item1 in item.labelVal" :label="item1.level" :key="item1.level">{{
                              item1.desc
                            }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="crowd">
              <div class="crowd-point">
                <span style="color:#000">推荐人群</span>
              </div>
              <div style="border: 1px solid #f0f0f0;">
                <div class="crowd-tab">
                  <div class="crowd-tab-head">
                    <div class="crowd-tab-name">人群名称</div>
                    <div class="crowd-tab-sm" style="color:#000">人群说明</div>
                  </div>
                  <div class="crowd-tab-middle" v-for="info in personLab.recommendList" :key="info.labelId">
                    <div class="crowd-tab-name nameAlign">
                      <el-radio style="width:97%" @change="radioChange" v-model="ruleForm.modelIds" :label="info.labelId">
                        <el-tooltip  class="item" effect="light" :content="info.labelName" placement="top-start">
                          <el-button class="overHiddle">{{ info.labelName }}</el-button>
                        </el-tooltip>
                      </el-radio>
                    </div>
                    <div class="crowd-tab-sm descbox" :class="{ descbox: info.labelVal && info.labelVal.length > 1 }">
                      {{ info.labelDesc }}
                      <template v-if="!disableCUS">
                        <div class="dx" v-if="info.labelVal && info.labelVal.length > 1">
                          <el-checkbox :disabled="disableCUS" style="display: inline-block;" v-model="starCheckAll" @change="handleCheckedStarChange"
                            >全选</el-checkbox
                          >
                          <el-checkbox-group @change="handleChang" style="display: inline-block;margin-left: 30px;" v-model="ruleForm.starVal">
                            <el-checkbox :disabled="disableCUS" v-for="item1 in info.labelVal" :label="item1.level" :key="item1.level">{{
                              item1.desc
                            }}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <el-form-item label="发送人数:" required>
              <el-input
                v-model="ruleForm.sendCount"
                @input="ruleForm.sendCount = getNumberData($event, 0)"
                @change="handleSendCount"
                show-word-limit
                placeholder="请输入"
                style="width: 140px"
              >
              </el-input>
              <el-tooltip class="item" effect="light" content="奖品发放总人数设置" placement="bottom">
                <el-button type="text" style="margin-left: 6px;width: 35px;">
                  <i class="el-icon-question" style="color: #ccc;"></i>
                </el-button>
              </el-tooltip>
              <el-checkbox v-model="ruleForm.isOutClose" style="margin-left:7px">
                勾选奖品发完自动结束活动
              </el-checkbox>
            </el-form-item>

            <el-form-item label="礼包奖项:" required v-if="false">
              <el-radio :disabled="giftYouDisabled" @change="changeHavePrizes" v-model="ruleForm.isHavePrizes" label="1">有奖项</el-radio>
              <el-radio :disabled="giftWuDisabled" @change="changeHavePrizes" v-model="ruleForm.isHavePrizes" label="2"
                >无奖项<span style="color:#999">（链接跳转）</span></el-radio
              >
            </el-form-item>

            <el-form-item label="礼包样式:" style="position: relative;" required>
              <template v-if="ruleForm.isHavePrizes == 2">
                <template v-if="false">
                  <el-button type="text" style="background: #FE4D45;color:#fff">上传图片</el-button>
                  <el-tooltip v-if="false" placement="bottom-start" effect="light" popper-class="tooplitMax">
                    <div slot="content" class="tooltipBox">
                      <div class="tooltipBox-left">
                        <div class="tooltipBoder"></div>
                        <div class="tooltipliji"></div>
                        <img src="../../assets/images/integralCenter/mengbantu.png" alt="" />
                      </div>
                      <div class="tooltipBox-right">
                        <div style="margin-top:28px">
                          <p class="p1">字体：</p>
                          <p class="p2">方正及汉仪字体（正文内容）</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">尺寸：</p>
                          <p class="p2">礼包整体尺寸（包括氛围素材） 630*788px</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">按钮：</p>
                          <p class="p2">“领取按钮”大小440*100px，位置居中于礼包下方，并且与礼包有明显的区分，清晰可见；</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">礼包主要区域要求：</p>
                          <p class="p2">礼包主要区域标题与正文区分，文字内容与礼包背景要有明显的差别，利益点突出，主次分明，利益点文案不得融入背景</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">氛围素材区域要求：</p>
                          <p class="p2">氛围素材区域剧中与礼包主要区域与整体页面，高度788px；氛围素材与利益点区分；</p>
                        </div>
                      </div>
                    </div>
                    <el-button type="text" style="color:#333">图片示例</el-button>
                  </el-tooltip>
                  <el-button type="text" style="background: #FE4D45;color:#fff;position: absolute;left: 466px;">上传图片</el-button>
                  <el-tooltip v-if="false" placement="bottom-start" effect="light" popper-class="tooplitMax">
                    <div slot="content" class="tooltipBox">
                      <div class="tooltipBox-left">
                        <div class="tooltipBoder"></div>
                        <div class="tooltipliji"></div>
                        <img src="../../assets/images/integralCenter/mengbantu.png" alt="" />
                      </div>
                      <div class="tooltipBox-right">
                        <div style="margin-top:28px">
                          <p class="p1">字体：</p>
                          <p class="p2">方正及汉仪字体（正文内容）</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">尺寸：</p>
                          <p class="p2">礼包整体尺寸（包括氛围素材） 630*788px</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">按钮：</p>
                          <p class="p2">“领取按钮”大小440*100px，位置居中于礼包下方，并且与礼包有明显的区分，清晰可见；</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">礼包主要区域要求：</p>
                          <p class="p2">礼包主要区域标题与正文区分，文字内容与礼包背景要有明显的差别，利益点突出，主次分明，利益点文案不得融入背景</p>
                        </div>
                        <div style="margin-top:20px">
                          <p class="p1">氛围素材区域要求：</p>
                          <p class="p2">氛围素材区域剧中与礼包主要区域与整体页面，高度788px；氛围素材与利益点区分；</p>
                        </div>
                      </div>
                    </div>
                    <el-button type="text" style="color:#333;position:absolute;left: 637px;">图片示例</el-button>
                  </el-tooltip>
                </template>
                <div style="display:flex;">
                  <div style="width: 540px;">
                    <el-button slot="reference"
                      @click="giftPopup = true,giftPopupNum = 1" type="text" style="background: #FE4D45;color:#fff">重新选择</el-button>
                    <div>非会员礼包<span style="color:#999">（非会员人群进入店铺时展示的礼包样式）</span></div>
                    <div class="wrapperBg" style="width: 235px;height: 419px;position: relative;">
                      <img class="giftImg" :src="templateUrlimg" :style="{ width: '210px', height: 788 / 3 + 'px' }" />
                    </div>
                    <div style="margin-top:20px">跳转链接<span style="color:#999">（建议设置开卡链接）</span></div>
                    <div>
                      <el-input
                        type="textarea"
                        class="textareabox"
                        placeholder="请输入链接"
                        style="width: 336px;"
                        resize="none"
                        v-model="ruleForm.jumpLink"
                      ></el-input>
                    </div>
                    <div style="margin-top:10px">
                      <span class="desc">
                        <i class="el-alert__icon el-icon-info"></i>
                        注：用户点击礼包跳转的落地页链接，如果不设置，则点击礼包默认关闭弹窗
                      </span>
                    </div>
                  </div>
                  <div style="width: 540px;">
                    <el-button slot="reference"
                      @click="giftPopup = true,giftPopupNum = 2"  type="text" style="background: #FE4D45;color:#fff">重新选择</el-button>
                    <div>
                      <el-checkbox v-model="ruleForm.isMemberGiftCheck"> 会员礼包 </el-checkbox
                      ><span style="color:#999">（如不勾选，则会员进入店铺则不弹出礼包）</span>
                    </div>
                    <div class="wrapperBg" style="width: 235px;height: 419px;position: relative;">
                      <img class="giftImg" :src="templateUrlimg1" :style="{ width: '210px', height: 788 / 3 + 'px' }" />
                    </div>
                    <div style="margin-top:20px">跳转链接<span style="color:#999">（建议设置优惠券\活动页面\商品页面的链接）</span></div>
                    <div>
                      <el-input
                        type="textarea"
                        class="textareabox"
                        placeholder="请输入链接"
                        style="width: 336px"
                        resize="none"
                        v-model="ruleForm.memberGiftJumpLink"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </template>

              <template v-if="ruleForm.isHavePrizes == 1">
                <span>当前样式只能设置4个奖项</span>
                <div class="shopSet">
                  <div class="shopSet-left">
                    <div class="shopSetLeft-connet">
                      <template v-for="(item, index) in libaoList">
                        <div
                          class="inner"
                          v-if="item.giftFalse"
                          :class="{ innerAction: item.backAction }"
                          :key="index"
                          @click="handleRemovePoint(item, index)"
                        >
                          <div class="innerTap" :class="{ innerTapAction: item.backAction }">
                            <div
                              v-if="item.backAction"
                              class="logoImg"
                              :class="[`img${index}`]"
                              :style="{ background: item.backAction ? `url(${item.hoverImg}) no-repeat` : `url(${item.logoImg}) no-repeat` }"
                            ></div>
                            <div v-else class="logoImg" :class="[`img${index}`]"></div>
                            <div class="innerTap-name">{{ item.name }}</div>
                            <div class="innerTap-bottom" :class="{ botAction: item.backAction }" @click.stop="handleClickPoint(item, index)">
                              选择
                            </div>
                          </div>
                          <div class="innerTip">{{ item.priceName }}</div>
                        </div>
                      </template>
                    </div>

                    <el-form-item label-width="150px" style="margin: 40px 0 0px -120px;" label="礼包确认按钮文案:" required>
                      <el-input v-model="ruleForm.buttonText"  maxlength="5" show-word-limit placeholder="礼包确认按钮文案" style="width: 200px"></el-input>
                    </el-form-item>
                  </div>
                  <div class="shopSet-right">
                    <div>
                      <el-button slot="reference"
                      @click="giftPopup = true,giftPopupNum = 3" type="text" style="background: #FE4D45;color:#fff">重新选择</el-button>
                      <el-tooltip  v-if="false" placement="bottom-start" effect="light" popper-class="tooplitMax">
                        <div slot="content" class="tooltipBox">
                          <div class="tooltipBox-left">
                            <div class="tooltipBoder"></div>
                            <div class="tooltipliji"></div>
                            <img src="../../assets/images/integralCenter/mengbantu.png" alt="" />
                          </div>
                          <div class="tooltipBox-right">
                            <div style="margin-top:28px">
                              <p class="p1">字体：</p>
                              <p class="p2">方正及汉仪字体（正文内容）</p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">尺寸：</p>
                              <p class="p2">礼包整体尺寸（包括氛围素材） 630*788px</p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">按钮：</p>
                              <p class="p2">“领取按钮”大小440*100px，位置居中于礼包下方，并且与礼包有明显的区分，清晰可见；</p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">礼包主要区域要求：</p>
                              <p class="p2">
                                礼包主要区域标题与正文区分，文字内容与礼包背景要有明显的差别，利益点突出，主次分明，利益点文案不得融入背景
                              </p>
                            </div>
                            <div style="margin-top:20px">
                              <p class="p1">氛围素材区域要求：</p>
                              <p class="p2">氛围素材区域剧中与礼包主要区域与整体页面，高度788px；氛围素材与利益点区分；</p>
                            </div>
                          </div>
                        </div>
                        <el-button type="text" style="color:#333">图片示例</el-button>
                      </el-tooltip>
                    </div>
                    <div class="wrapperBg" style="margin-top:25px;width: 235px;height: 419px;position: relative;">
                      <img class="giftImg" :src="templateUrlimg" :style="{ width: '210px', height: 788 / 3 + 'px' }" />
                      <span class="giftBottom">{{ ruleForm.buttonText }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-form-item>
          </template>

          <template v-if="activityData.id != 13 && activityData.id != 14">
            <el-form-item label="活动规则:" required>
              <div
                style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
              >
                <el-input
                  type="textarea"
                  class="textarea"
                  style="width: 484px;"
                  resize="none"
                  v-model="ruleForm.activityRulesText"
                  :disabled="backgroundOpacity"
                  :maxlength="2000"
                ></el-input>
                <div class="prosi" style="color: #909399">
                  （{{ ruleForm.activityRulesText.length ? ruleForm.activityRulesText.length : 0 }}/2000）
                </div>
                <div>
                  <el-button type="primary" class="generate" plain @click="generateRule" :disabled="backgroundOpacity">
                    生成规则
                  </el-button>

                  <span class="desc">
                    <i class="el-alert__icon el-icon-info" style="color:#999"></i>
                    点击按钮自动生成规则，也可以自己编辑信息
                  </span>
                </div>
              </div>
            </el-form-item>
          </template>
        <div v-if="backgroundOpacity" class="backgroundOpacity"></div>
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
        <el-button v-show="!itemId" class="createBtn create_bottom_returnBtn" size="medium" @click="clickLocalStep()">{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</el-button>
        <template v-if="!backgroundOpacity">
          <el-button v-show="!itemId" v-if="isSave" class="createBtn create_bottom_keepBtn" type="primary" size="medium" @click="saveEdit" v-preventReClick>保存设置</el-button>
        </template>
        <el-button v-show="itemId" class="createBtn create_bottom_returnBtn" size="medium" @click="cancelEdit">取消</el-button>
        <el-button v-show="itemId" class="createBtn create_bottom_keepBtn" type="primary" size="medium">保存设置</el-button>
    </div>
    
    <selectGoodsMonitor 
      v-if="selectGoodsState" 
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr" 
      :maxNum="20">
    </selectGoodsMonitor>
    
    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 确定礼包模板弹窗 -->
    <gift-popup :activityDataID="activityData.id" @handleChoice="handleChoice" v-if="giftPopup" />
    <!-- 选择奖品弹窗 -->
    <selectProduct 
      @close="colseDialog" 
      :num="1" 
      :JingdouCount="JingdouCount" 
      :isShowRemarkOrder="isShowRemarkOrder" 
      v-if="showDialog" 
      :picShow = 'activityData.name=="邀请关注店铺有礼"?true:false'
      ref="selectProduct" 
      @choose-shop="getTheData"> </selectProduct>
    <!-- 选择奖品弹窗 -->
    <selectProduct 
      @close="colseDialog1" 
      :num="1" 
      :JingdouCount="JingdouCount" 
      :isShowRemarkOrder="isShowRemarkOrder"
      v-if="showDialog1" 
      ref="selectProduct1" @choose-shop="getTheData1"> </selectProduct>
    
    <selectPrize v-model="dialogPrize" :num="1" :JingdouCount="JingdouCount" :libaoItem="libaoItem" @closePrize="closePrize"></selectPrize>

  </div>
</template>

<script>
import giftPopup from "./giftPopup.vue";
import {
  creatIntegral,
  editIntegral,
  searchIntegral,
  focusStores,
  editfocusStores,
  searchfocusStores,
  invite,
  editInvite,
  searchInvite,
  follow,
  editfollow,
  searchfollow,
  information,
  editInformationAa,
  searchInformation,
  creatPrize,
  editPrize,
  searchPrize,
} from "@/api/integralCenter/integralTask";
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";
import {
  getPersonLabelList,
  createShopGift,
  getGiftBagTemplate,
  getGiftBagList,
  giftBagEide,
  editShopGift,
  getValidActivity,
} from "@/api/paradiseAndTaskCommonController.js";
const prizeName = ["", "", "京豆", "实物", "店铺积分", "淘宝E卡", "爱奇艺会员", "淘宝PLUS会员", "现金红包"];
export default {
  components: {
    selectProduct,
    selectPrize,
    selectGoodsMonitor,
    draggable,
    giftPopup,
  },
  data() {
    return {
      crowdList: [],
      isShowRemanentAmount:1,
      filterInviteOption:0,
      msgOptions: [
        {
          label: "文本",
          value: 1
        },
        {
          label: "图片",
          value: 2
        }
      ],
      isStartEditTime:'',
      isStartEdit:false,
      isClick: false,
      isCopy: false, // 是否复制
      isShowRemarkOrder: false, // 是否展示备注订单
      awardSettingsLsit: [  // 奖品设置列表
        { 
          singleAmount: "",
          assetsId: null,
          prizeType: "",
          title: "",
          price: "",
          totalAmount: null
        },
      ],
      itemIndex: 0,
      disItem:0,
      valueRow:null,
      localStepNum:0,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      giftPopup: false,
      giftPopupNum: 0,
      navList: [],
      tabActive: 0,
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.$store.state.loginUserInfo.expiredIn).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      templateUrlimg: "",
      templateUrlimg1: "", // 开卡礼包会员
      memberGiftTemplateId: "", //开卡礼包会员礼包id
      giftWuDisabled: false,
      giftYouDisabled: false,
      giftPrizeType: [], // 礼包样式数量
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftID: "", // 礼包id
      giftList: [], // 礼包模板
      disableVF: true, // 人群禁用
      disableCUS: true, //  人群禁用
      dialogPrize: false, // 弹窗
      currtIndex: -3,
      libaoItem: {}, // 选中的item
      // 礼包样式四个奖品
      libaoList: [
        {
          name: "店铺积分",
          priceName: "每份店铺积分：1",
          logoImg: require("../../assets/images/integralCenter/zu6828.svg"),
          hoverImg: require("../../assets/images/integralCenter/zu12.svg"),
          singleAmount: "1",
          prizeType: "6", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: true,
          totalAmount: "1", //总共奖品数量
          giftFalse: false,
        },
        {
          name: "京豆",
          priceName: "每份京豆额：0",
          logoImg: require("../../assets/images/integralCenter/zu6829.svg"),
          hoverImg: require("../../assets/images/integralCenter/zu13.svg"),
          singleAmount: "", //单份奖励数量 例如一次发放10个京豆就传10，一次发放一个6.66元的红包就传1
          prizeType: "4", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: false,
        },
        {
          name: "东券",
          priceName: "0元优惠券",
          logoImg: require("../../assets/images/integralCenter/zu6826.svg"),
          hoverImg: require("../../assets/images/integralCenter/zu14.svg"),
          singleAmount: "1",
          prizeType: "1", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: false,
        },
        {
          name: "京券",
          priceName: "0元优惠券",
          logoImg: require("../../assets/images/integralCenter/zu6827.svg"),
          hoverImg: require("../../assets/images/integralCenter/zu15.svg"),
          singleAmount: "1",
          prizeType: "0", //奖项类型  0:京券 1:东券 4:京豆 6:积分
          backAction: false,
          totalAmount: "0", //总共奖品数量
          assetsId: "",
          giftFalse: false,
        },
      ],
      // 获取人群
      personLab: {
        customizeList: [],
        recommendList: [],
      },
      // 人群多选
      verCheckAll: false,
      starCheckAll: false,
      levelList: [],
      disableTime: false,
      clickActual: false,
      qrcode: null,
      order: "",
      showDialog: false,
      showDialog1: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return time.getTime(time) < new Date(this.ruleForm.activityStartTime).getTime();
            } else {
              return time.getTime(time) + day < new Date(this.ruleForm.activityStartTime).getTime();
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return time.getTime() > new Date(this.ruleForm.activityEndTime).getTime();
          } else {
          }
        },
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      activityStartTime: null,
      activityEndTime: null,
      ruleForm: {
        membershipTime:"",
        // 活动对象
        activityObject: 0,
        // 新老客户
        newOldCustomer: 0,
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        privacySelected: false, // 设置隐私政策
        improveInformationPrivacyDTO: { // 隐私正常信息
          privacyTitle: "隐私政策", // 标题
          isNecessary: true, // 勾选条件
          privacyDescription: "", // 内容
        },
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: "", //活动开始时间
        activityEndTime: "", //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        // 开卡  店铺
        modelIds: "", //活动对应的人群包id
        vermicelliVal: [], //活动对应的人群包多选
        starVal: [], //活动对应的人群包多选
        sendCount: "", //发送人数
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是
        buttonText: "", //礼包确认按钮文案
        requestFollow: "1", // 是否需要关注店铺
        jumpLink: "", //跳转链接
        memberGiftJumpLink: "", //会员礼包跳转链接
        isMemberGiftCheck: false,
        isHavePrizes: "2",
        prizes: [], // 礼包样式  积分  京豆等等
        itemList: [], //曝光商品集合
        exclusion:true,
      },
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          price: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        activityRulesText: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      generalCoupon: { // 通用优惠券
        couponType: 0
      }, 
    };
  },
  computed: {
    selectCrowdText() {
      return this.crowdList.length === 0
        ? "选择人群"
        : `已选${this.crowdList.length}个`;
    },
  },
  async created() {
    this.activityData = this.$route.query.activityData
    this.localStepNum = this.activityData.id
    console.log('this.$route.query------>', this.$route.query)
    console.log('this.localStepNum------>', this.localStepNum)
    if (this.$route.query.valueRow) {
      this.backgroundOpacity = this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment = this.$route.query.statusComment == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.typeDetail();
    } else if (this.$route.query.copyParams) { // 复制
      this.isCopy = true
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.typeDetail();
    } else{
      this.activityTimeChange();
    }
    console.log('this.activeValue------>', this.activeValue)
  },
  filters: {
    prizeType(num) {
      var result = "";
      if(num == "1"){
        result = "优惠券";
      }else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "淘宝E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "淘宝PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "专属实物";
      }
      return result;
    },
  },
  mounted() {
    this.getLevel();
    // //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
  },
  methods: {
    handleChangeSelected(val,row,index) {
     this.itemArrOne.splice(index,1,{
        selected: val ? 1 : 0,
        informationmationSelect: row.informationmationSelect,
        informationmationOne: row.informationmationOne
      })
    },
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.crowdList = [];
    },
    handleSelect(val,index) {
      this.itemArrOne[index].informationmationOne = ""
    },
    //回显
    typeDetail(){
      if (this.activeValue == 4) {
      //关注店铺有礼
      searchfocusStores({ id: this.valueRow.id })
        .then((res) => {
          let datas, change1, change2, days, daysStart, daysEnd, date3;
          daysStart = res.data.startTime.substring(0, 10);
          daysEnd = res.data.endTime.substring(0, 10);
          datas = daysEnd.split("-");
          change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          datas = daysStart.split("-");
          change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
          days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
          this.timeDay = days;
          //计算小时
          date3 =
            new Date(res.data.endTime).getTime() -
            new Date(res.data.startTime).getTime();
          let leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.activityStartTime = String(res.data.startTime);
          this.ruleForm.activityEndTime = String(res.data.endTime);
          this.ruleForm.activityObject = res.data.hasOwnProperty(
            "activityObject"
          )
            ? res.data.activityObject
            : 0;
          this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
            "newOldCustomer"
          )
            ? Number(res.data.newOldCustomer)
            : 0;
          this.crowdList = res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
            ? res.data.seniorGroupId.split(",")
            : [];
          if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
          if (this.isCopy) {
            this.ruleForm.bonusPoints = "";
            this.ruleForm.activityRulesText = ""; //生成规则
          } else {
            this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
            this.ruleForm.bonusPoints = Number(res.data.pointActivityPrizeDTO.price);
            this.ruleForm.minNum = Number(res.data.pointActivityPrizeDTO.price);
          }
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.partner = res.data.allowLevel.split(",");
          //曝光商品
          this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
          console.log(this.ruleForm.exposureSwitch);
          // 商品处理
          let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;
          this.ruleForm.radio = res.data.priceType;
          this.itemListFor = shopList;
          console.log(this.itemListFor);
          this.activityTimeChange();
        })
        .catch(() => {});
    } else if (this.activeValue == 5) {
      //邀请开卡
      searchInvite({ id: this.valueRow.id }).then((res) => {
        this.ruleForm.isCumulativePrize = res.data.ruleDto.isCumulativePrize;
        if (res.data.ruleDto.isCumulativePrize) {
          this.tableData = res.data.ruleDto.cumulativePrizes.map((item, index) => {
            let obj = {
              id:item.cumulativePrizeDTO.pointActivityPrizeId,
              peopleCount: item.cumulativeNum,
              title: item.cumulativePrizeDTO.title,
              assetsId: item.cumulativePrizeDTO.assetsId,
              prizeType: item.cumulativePrizeDTO.prizeType,
              logo: item.cumulativePrizeDTO.logo,
              discount: item.cumulativePrizeDTO.price || item.cumulativePrizeDTO.singleAmount,
              singleAmount: item.cumulativePrizeDTO.singleAmount,
            };
            return obj;
          });
        } else {
          let prize = res.data.ruleDto.cumulativePrizes;
          this.ruleForm.prizeCount = prize[0].cumulativePrizeDTO.totalAmount;
          this.prizeSettingList = {
            id: prize[0].cumulativePrizeDTO.id,
            price: prize[0].cumulativePrizeDTO.price,
            title: prize[0].cumulativePrizeDTO.title,
            assetsId: prize[0].cumulativePrizeDTO.assetsId,
            prizeType: prize[0].cumulativePrizeDTO.prizeType,
            logo: prize[0].cumulativePrizeDTO.logo,
            discount: prize[0].cumulativePrizeDTO.singleAmount,
          };
          this.ruleForm.peopleCount = String(res.data.ruleDto.maxInviteNum);
        }
        this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.activityObject = res.data.hasOwnProperty(
          "activityObject"
        )
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
          "newOldCustomer"
        )
          ? Number(res.data.newOldCustomer)
          : 0;
        this.crowdList = res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
          ? res.data.seniorGroupId.split(",")
          : [];
        this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        // 商品处理
          let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.itemListFor = shopList;
        this.mainImagelist = shopList;
        this.ruleForm.radio = res.data.priceType;
        this.activityTimeChange();
      });
    } else if (this.activeValue == 6) {
      //邀请关注店铺
      searchfollow({ id: this.valueRow.id }).then((res) => {
        this.isShowRemanentAmount = res.data.ruleDto.isShowRemanentAmount?res.data.ruleDto.isShowRemanentAmount:0
        this.filterInviteOption = res.data.ruleDto.filterInviteOption?res.data.ruleDto.filterInviteOption:0
        if (res.data.ruleDto.isCumulativePrize) {
          this.ruleForm.isCumulativePrize = res.data.ruleDto.isCumulativePrize;
          if (!this.isCopy) {
            this.tableData = res.data.ruleDto.cumulativePrizes.map((item, index) => {
              console.log("item.",item)
              let obj = {
                id:item.cumulativePrizeDTO.pointActivityPrizeId,
                peopleCount: item.cumulativeNum,
                title: item.cumulativePrizeDTO.title,
                assetsId: item.cumulativePrizeDTO.assetsId,
                prizeType: item.cumulativePrizeDTO.prizeType,
                logo: item.cumulativePrizeDTO.logo,
                price: item.cumulativePrizeDTO.price || item.cumulativePrizeDTO.singleAmount,
                singleAmount: Number(item.cumulativePrizeDTO.singleAmount),
                prizeCount: item.cumulativePrizeDTO.totalAmount,
              };
              if(item.cumulativePrizeDTO.couponType == 4) {
                obj.couponType = 4
                obj.assetsId = null
                obj.batchKey = item.cumulativePrizeDTO.batchKey
              }
              return obj;
            });
            this.tableData.forEach(item=>item.minNum=item.prizeCount)
          } else {
            this.tableData = [
              {
                peopleCount: "",
                prizeType: "",
                discount: "",
                price: "",
                prizeCount: "",
                singleAmount: "",
              },
            ]
          }
        } else {
            let prize = res.data.pointActivityPrizeDTO;
            this.ruleForm.prizeCount = this.isCopy ? null : prize.totalAmount;
            if(prize.couponType == 4) {
              this.prizeSettingList = {
                id:prize.id,
                singleAmount: prize.singleAmount,
                price: prize.price,
                title: prize.title,
                assetsId: prize.assetsId,
                prizeType: prize.prizeType,
                logo: prize.logo,
                discount: prize.singleAmount,
              };
            } else {
              this.prizeSettingList = {
                id: prize.id,
                singleAmount: prize.singleAmount,
                price: prize.price,
                title: prize.title,
                assetsId: prize.assetsId,
                prizeType: prize.prizeType,
                logo: prize.logo,
                price: prize.singleAmount,
                discount: prize.singleAmount,
              };
            }
            if (this.isCopy) {
              this.prizeSettingList = {
                price: null,
                title: "",
                assetsId: null,
                prizeType: null,
                logo: "",
                discount: "",
                singleAmount: "",
              }
            }
           this.setPrizeTxt(this.prizeSettingList);
           this.ruleForm.peopleCount = String(res.data.ruleDto.maxInviteNum) || ""; 
        }
        this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.activityObject = res.data.hasOwnProperty(
          "activityObject"
        )
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
          "newOldCustomer"
        )
          ? Number(res.data.newOldCustomer)
          : 0;
        this.crowdList = res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
          ? res.data.seniorGroupId.split(",")
          : [];
        this.ruleForm.activityRulesText = this.isCopy ? "" : String(res.data.ruleDescription); //生成规则
        this.ruleForm.peopleCount = String(res.data.ruleDto.maxInviteNum);
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        //曝光商品
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        // 商品处理
          let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.itemListFor = shopList;
        this.mainImagelist = shopList;
        this.ruleForm.radio = res.data.priceType;
        this.activityTimeChange();
      });
    } else if (this.activeValue == 7) {
      //完善信息有礼
      searchInformation({ id: this.valueRow.id })
        .then((res) => {
          console.log(res,'2233');
          
          this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
          if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
          this.ruleForm.activityName = res.data.activityName;
          this.ruleForm.exclusion = res.data.ruleDto.exclusion == 1 ? true : false;
          this.ruleForm.activityStartTime = String(res.data.startTime);
          this.ruleForm.activityEndTime = String(res.data.endTime);
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.partner = res.data.allowLevel.split(",");
            this.ruleForm.activityObject = res.data.hasOwnProperty(
              "activityObject"
            )
              ? res.data.activityObject
              : 0;
            this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
              "newOldCustomer"
            )
              ? Number(res.data.newOldCustomer)
              : 0;
            this.crowdList = res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
              ? res.data.seniorGroupId.split(",")
              : [];
          this.ruleForm.activityRulesText = this.isCopy ? "" : String(res.data.ruleDescription); //生成规则
          this.ruleForm.bonusPoints = this.isCopy ? "" : String(res.data.pointActivityPrizeDTO.price);
          this.ruleForm.minNum = this.isCopy ? "" : String(res.data.pointActivityPrizeDTO.price);
          this.ruleForm.information = res.data.ruleDto.infoNames;
          this.ruleForm.privacySelected = res.data.ruleDto.privacySelected;
          this.ruleForm.improveInformationPrivacyDTO = res.data.ruleDto.improveInformationPrivacyDTO;
          this.ruleForm.improveInformationPrivacyDTO.isNecessary = res.data.ruleDto.improveInformationPrivacyDTO.isNecessary == 1 ? true : false;

          //返回数组转换成数组对象
          let arrList = [];
          // for (let i in res.data.ruleDto.staticInfoNames) {
          //   let index=0;
          //   var j = {};
          //   // j.informationmationOne = res.data.ruleDto.staticInfoNames[i];
          //   j.informationmationOne = res.data.ruleDto.staticInfoNames[i].name;
          //   j.informationmationSelect = res.data.ruleDto.staticInfoNames[i].type;
          //   j.selected = res.data.ruleDto.staticInfoNames[i].selected==null || res.data.ruleDto.staticInfoNames[i].selected==1 ? 1 : 0
          //   if(res.data.ruleDto.staticInfoNames[i].selected==null || res.data.ruleDto.staticInfoNames[i].selected==1) {
          //     this.ruleForm.informationOne.push(index);
          //   }
          //   index++;
          //   arrList.push(j);
          // }
          if (res.data.ruleDto.staticInfoNames.length > 0) {
            res.data.ruleDto.staticInfoNames.forEach((item,index) => {
              if(item.selected==null || item.selected==1) {
                this.ruleForm.informationOne.push(index);
              }
              arrList.push({
                informationmationOne: item.name,
                informationmationSelect: item.type,
                selected: item.selected==null || item.selected==1 ? 1 : 0
              });
            });
          }
          this.itemArrOne = arrList;
          this.handleDischange()
          this.activityTimeChange();
        })
        .catch(() => {});
    } else if (this.activeValue == 1) {
      //日历签到
      searchIntegral({ id: this.valueRow.id }).then((res) => {
        this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
        // console.log(res.data);
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
            this.ruleForm.activityObject = res.data.hasOwnProperty(
              "activityObject"
            )
              ? res.data.activityObject
              : 0;
            this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
              "newOldCustomer"
            )
              ? Number(res.data.newOldCustomer)
              : 0;
            this.crowdList = res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
              ? res.data.seniorGroupId.split(",")
              : [];
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.isFollow = res.data.ruleDto.requestFollow; //参与条件
        if (this.isCopy) {
          console.log('999999');
          this.ruleForm.activityRulesText = ""
          this.awardSettingsLsit = [
            { 
              singleAmount: "",
              assetsId: null,
              prizeType: "",
              title: "",
              price: "",
              totalAmount: null
            },
          ]
          this.ruleForm.prizeSetOne = false;
          this.itemArr = [
            {
              continueSignPoints: "",
              days: "",
            },
          ]
          this.ruleForm.prizeSet = false;
        } else {
          this.prizeSettingList = res.data.pointActivityPrizeDTO
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.awardSettingsLsit = [res.data.pointActivityPrizeDTOList[0]]
          this.awardSettingsLsit.forEach(item=>item.minNum=item.totalAmount)
          this.ruleForm.prizeSetOne = true;
          this.itemArr = res.data.pointActivityPrizeDTOList.filter((item, index) => {
            item.days = item.signSequenceTimes
            return index != 0
          })
          this.itemArr.forEach(item=>item.minNum=item.totalAmount)
          this.ruleForm.prizeSet = true;
          if(this.itemArr.length) {
            this.ruleForm.prizeSetOne = true;
          }else {
            this.ruleForm.prizeSetOne = false;
          }
        }
        if (res.data.pointActivityPrizeDTO.price != "") {
          this.limit = false;
        }
        this.ruleForm.inputprize = String(res.data.pointActivityPrizeDTO.price);
        //曝光商品
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        // 商品处理
          let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        this.itemListFor = shopList;
        this.mainImagelist = shopList;
        this.ruleForm.radio = res.data.priceType;
        this.activityTimeChange();
        // this.ruleForm.isFollow  活动条件
      });
    } else if (this.activeValue == 3) {
      //每日抢好礼
      searchPrize({ id: this.valueRow.id }).then((res) => {
        this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
        this.ruleForm.activityName = res.data.activityName;
        this.ruleForm.activityStartTime = String(res.data.startTime);
        this.ruleForm.activityEndTime = String(res.data.endTime);
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.activityObject = res.data.hasOwnProperty(
          "activityObject"
        )
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
          "newOldCustomer"
        )
          ? Number(res.data.newOldCustomer)
          : 0;
        this.crowdList = res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
          ? res.data.seniorGroupId.split(",")
          : [];
        this.ruleForm.isFollow = res.data.ruleDto.requestFollow; //参与条件
        this.ruleForm.startTime = res.data.ruleDto.startTime;
        
        if (this.isCopy) {
          this.prizeSettingList = {
            price: null,
            title: "",
            assetsId: null,
            prizeType: null,
            logo: "",
            discount: "",
            singleAmount: "",
          }
          this.ruleForm.activityRulesText = "";
          this.ruleForm.prizeCount = null;
        } else {
          this.prizeSettingList = res.data.pointActivityPrizeDTO;
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
          this.ruleForm.prizeCount = res.data.ruleDto.prizeCount;
          this.ruleForm.minNum = res.data.ruleDto.prizeCount;
        }

        if (res.data.pointActivityPrizeDTO.prizeType == 4) {
          this.prizeSettingList.title = res.data.pointActivityPrizeDTO.price + "店铺积分";
        } else {
          this.prizeSettingList.title = res.data.pointActivityPrizeDTO.title;
        }
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        // 商品处理
          let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.mainImagelist = shopList;
        this.selectGoodsArr = shopList;
        this.itemListFor = shopList;
        this.mainImagelist = shopList;
        this.ruleForm.radio = res.data.priceType;
        this.activityTimeChange();
      });
    } else if (this.activeValue == 13) {
      // 开卡礼包
      this.fromLoading = true;
      giftBagEide(this.valueRow.id).then((res) => {
        this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
        this.ruleForm.activityName = res.data.activityName; //活动类型  13: 开卡礼包 14: 店铺礼包
        this.ruleForm.activityStartTime = res.data.startTime;
        this.ruleForm.activityEndTime = res.data.endTime;
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.activityObject = res.data.hasOwnProperty(
          "activityObject"
        )
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
          "newOldCustomer"
        )
          ? Number(res.data.newOldCustomer)
          : 0;
        this.crowdList = res.data.hasOwnProperty("seniorGroupId") && res.data.seniorGroupId
          ? res.data.seniorGroupId.split(",")
          : [];
        this.giftID = res.data.giftTemplateId;
        // if(){
        //   this.ruleForm.isExposureItem = res.data.ruleDTO.isExposureItem; //是否添加曝光商品 0 否 1 是
        // }
        this.ruleForm.buttonText = res.data.ruleDto.buttonText;
        this.ruleForm.isOutClose = res.data.ruleDto.isOutClose;
        this.ruleForm.isHavePrizes = res.data.ruleDto.isHavePrizes ? "1" : "2";
        if(this.ruleForm.isHavePrizes == '2'){
          this.memberGiftTemplateId = res.data.memberGiftTemplateId;
          this.templateUrlimg1 = res.data.memberGiftTemplateUrl;
        }
        this.ruleForm.requestFollow = res.data.ruleDto.requestFollow ? "1" : "2"; //是否需要关注店铺
        this.ruleForm.sendCount = res.data.ruleDto.sendCount;
        this.ruleForm.jumpLink = res.data.ruleDto.jumpLink;
        this.ruleForm.isMemberGiftCheck = res.data.ruleDto.isMemberGiftCheck;
        this.ruleForm.memberGiftJumpLink = res.data.ruleDto.memberGiftJumpLink;
        this.ruleForm.modelIds = res.data.ruleDto.modelIds;
        //人群处理
        if (res.data.ruleDto.modelIds.indexOf(":") != -1) {
          const list = res.data.ruleDto.modelIds.split(":");
          const data = list[1].split("_");
          this.ruleForm.modelIds = list[0];
          if (list[0] == "v1_new_p" || list[0] == "v1_plus" || list[0] == "v1_new_fans") {
            this.ruleForm.vermicelliVal = [];
            this.ruleForm.starVal = [];
          }
          // 、、粉丝
          if (list[0] == "v1_no_f") {
            if (data.length == 4) {
              this.verCheckAll = true;
            }
            this.disableVF = false;
            this.ruleForm.vermicelliVal = data;
          }
          // 星极
          if (list[0] == "v1_customer") {
            if (data.length == 6) {
              this.starCheckAll = true;
            }
            this.disableCUS = false;
            this.ruleForm.starVal = data;
          }
        }
        res.data.giftTemplatePrizeType = res.data.giftTemplatePrizeType ? res.data.giftTemplatePrizeType : ''
        // 礼包模板设置显示奖项 1 店铺积分  2 京豆  3  京券  4  东券")
        const numGift1 = res.data.giftTemplatePrizeType.indexOf("1");
        const numGift2 = res.data.giftTemplatePrizeType.indexOf("2");
        const numGift3 = res.data.giftTemplatePrizeType.indexOf("3");
        const numGift4 = res.data.giftTemplatePrizeType.indexOf("4");
        // 礼包样式
        this.libaoList.forEach((item) => {
          res.data.prizes.forEach((info) => {
            if (numGift1 != -1) {
              if (item.prizeType == "6") {
                item.giftFalse = true;
              }
            }
            if (numGift2 != -1) {
              if (item.prizeType == "4") {
                item.giftFalse = true;
              }
            }
            if (numGift3 != -1) {
              if (item.prizeType == "0") {
                item.giftFalse = true;
              }
            }
            if (numGift4 != -1) {
              if (item.prizeType == "1") {
                item.giftFalse = true;
              }
            }
            if (item.prizeType == info.prizeType) {
              if (info.prizeType == 6) {
                item.priceName = "每份店铺积分：" + info.price;
                item.singleAmount = info.price;
                item.assetsId = info.assetsId;
                item.backAction = true;
              }
              if (info.prizeType == 4) {
                item.priceName = "每份京豆额：" + info.price;
                item.assetsId = info.assetsId;
                item.singleAmount = info.price;
                item.backAction = true;
              }
              if (info.prizeType == 1) {
                item.priceName = info.price + "优惠券";
                item.singleAmount = 1;
                item.assetsId = info.assetsId;
                item.backAction = true;
              }
              if (info.prizeType == 0) {
                item.priceName = info.price + "优惠券";
                item.singleAmount = 1;
                item.assetsId = info.assetsId;
                item.backAction = true;
              }
            }
          });
        });
        this.ruleForm.prizes = res.data.prizes;
        this.templateUrlimg = res.data.giftTemplateUrl;
        //曝光商品集合
        
        
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        // 商品处理
          let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.ruleForm.radio = res.data.isExposureItem;
        this.selectGoodsArr = shopList;
        this.mainImagelist = shopList;
        this.itemListFor = shopList;
        this.activityTimeChange();
        this.fromLoading = false;
      });
    } else if (this.activeValue == 14) {
      // 店铺礼包
      giftBagEide(this.valueRow.id).then((res) => {
        this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
        if(this.isStartEdit){
            //进行中活动 无法修改活动开启时间
            this.isStartEditTime = String(res.data.startTime)
          }
        // console.log(res);
        this.fromLoading = true;
        this.ruleForm.activityName = res.data.activityName; //活动类型  13: 开卡礼包 14: 店铺礼包
        this.ruleForm.activityStartTime = res.data.startTime;
        this.ruleForm.activityEndTime = res.data.endTime;
        this.ruleForm.membershipTime = res.data.membershipTime
        this.ruleForm.partner = res.data.allowLevel.split(",");
        this.ruleForm.activityObject = res.data.hasOwnProperty(
          "activityObject"
        )
          ? res.data.activityObject
          : 0;
        this.ruleForm.newOldCustomer = res.data.hasOwnProperty(
          "newOldCustomer"
        )
          ? Number(res.data.newOldCustomer)
          : 0;
        this.crowdList = res.data.hasOwnProperty("seniorGroupId") && data.seniorGroupId
          ? res.data.seniorGroupId.split(",")
          : [];
        this.giftID = res.data.giftTemplateId;
        // if(){
        //   this.ruleForm.isExposureItem = res.data.ruleDTO.isExposureItem; //是否添加曝光商品 0 否 1 是
        // }
        this.ruleForm.buttonText = res.data.ruleDto.buttonText;
        this.ruleForm.isOutClose = res.data.ruleDto.isOutClose;
        this.ruleForm.isHavePrizes = res.data.ruleDto.isHavePrizes ? "1" : "2";
        if(this.ruleForm.isHavePrizes == '2'){
          this.memberGiftTemplateId = res.data.memberGiftTemplateId;
          this.templateUrlimg1 = res.data.memberGiftTemplateUrl;
        }
        this.ruleForm.requestFollow = res.data.ruleDto.requestFollow ? "1" : "2"; //是否需要关注店铺
        this.ruleForm.sendCount = res.data.ruleDto.sendCount;
        this.ruleForm.jumpLink = res.data.ruleDto.jumpLink;
        this.ruleForm.isMemberGiftCheck = res.data.ruleDto.isMemberGiftCheck;
        this.ruleForm.memberGiftJumpLink = res.data.ruleDto.memberGiftJumpLink;
        this.ruleForm.modelIds = res.data.ruleDto.modelIds;
        //人群处理
        if (res.data.ruleDto.modelIds.indexOf(":") != -1) {
          const list = res.data.ruleDto.modelIds.split(":");
          const data = list[1].split("_");
          this.ruleForm.modelIds = list[0];
          if (list[0] == "v1_new_p" || list[0] == "v1_plus" || list[0] == "v1_new_fans") {
            this.ruleForm.vermicelliVal = [];
            this.ruleForm.starVal = [];
          }
          // 、、粉丝
          if (list[0] == "v1_no_f") {
            if (data.length == 4) {
              this.verCheckAll = true;
            }
            this.disableVF = false;
            this.ruleForm.vermicelliVal = data;
          }
          // 星极
          if (list[0] == "v1_customer") {
            if (data.length == 6) {
              this.starCheckAll = true;
            }
            this.disableCUS = false;
            this.ruleForm.starVal = data;
          }
        }
        // 礼包模板设置显示奖项 1 店铺积分  2 京豆  3  京券  4  东券")
        res.data.giftTemplatePrizeType = res.data.giftTemplatePrizeType ? res.data.giftTemplatePrizeType : ''
        const numGift1 = res.data.giftTemplatePrizeType.indexOf("1");
        const numGift2 = res.data.giftTemplatePrizeType.indexOf("2");
        const numGift3 = res.data.giftTemplatePrizeType.indexOf("3");
        const numGift4 = res.data.giftTemplatePrizeType.indexOf("4");
        // 礼包样式
        this.libaoList.forEach((item) => {
          res.data.prizes.forEach((info) => {
            if (numGift1 != -1) {
              if (item.prizeType == "6") {
                item.giftFalse = true;
              }
            }
            if (numGift2 != -1) {
              if (item.prizeType == "4") {
                item.giftFalse = true;
              }
            }
            if (numGift3 != -1) {
              if (item.prizeType == "0") {
                item.giftFalse = true;
              }
            }
            if (numGift4 != -1) {
              if (item.prizeType == "1") {
                item.giftFalse = true;
              }
            }
            if (item.prizeType == info.prizeType) {
              if (info.prizeType == 6) {
                item.priceName = "每份店铺积分：" + info.price;
                item.singleAmount = info.price;
                item.assetsId = info.assetsId;
                item.backAction = true;
              }
              if (info.prizeType == 4) {
                item.priceName = "每份京豆额：" + info.price;
                item.singleAmount = info.price;
                item.assetsId = info.assetsId;
                item.backAction = true;
              }
              if (info.prizeType == 1) {
                item.priceName = info.price + "优惠券";
                item.singleAmount = 1;
                item.assetsId = info.assetsId;
                item.backAction = true;
              }
              if (info.prizeType == 0) {
                item.priceName = info.price + "优惠券";
                item.singleAmount = 1;
                item.assetsId = info.assetsId;
                item.backAction = true;
              }
            }
          });
        });
        this.ruleForm.prizes = res.data.prizes;
        //曝光商品集合
        this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
        // 商品处理
          let shopList = res.data.itemList
          ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
        this.selectGoodsArr = shopList;
        // this.itemListFor = res.data.itemList;
        this.mainImagelist = shopList;
        this.ruleForm.radio = res.data.isExposureItem;
        this.templateUrlimg = res.data.giftTemplateUrl;
        this.itemListFor = shopList;
        this.activityTimeChange();
        this.fromLoading = false;
      });
    }
    },
    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.handleGiftBag();
    },
    handleDischange(){
      let isdisable = false
      this.ruleForm.information.forEach(item=>{
        if(item == '-1')isdisable = true
      })
      if(isdisable) this.disItem = 2
      if(!isdisable && this.ruleForm.information.length > 0) this.disItem = 1
      if(this.ruleForm.information.length ==0) this.disItem = 0
    },
    // 礼包模板
    async handleGiftBag() {
      // 开卡礼包版本
      const { data } = await getGiftBagTemplate({ dirId: this.navItem.id });
      const giftList = data.map((item) => ({
        ...item,
        days: item.expirationType == 1 ? this.getDaysBetween(item.expirationStartDate, item.expirationEndDate) : "",
      }));
      if (this.activityData.id == 13) {
        this.giftList = giftList.filter((i) => i.giftType == 0);
      }
      if (this.activityData.id == 14) {
        this.giftList = giftList.filter((i) => i.giftType == 1);
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },
    addPrizeRule() {
      if(this.isStartEdit) return;
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },
    colseDialog1() {
      this.showDialog1 = false;
      this.clickActual1 = false;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      const url = this.activityData.id == 14 ? "http://index.yeionsms.com/yidongd/shop.html" : "http://index.yeionsms.com/yidongd/index.html";
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 117, // 设置宽度，单位像素
          height: 117, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text:
            this.activityData.id == 13
              ? `${url}?image=${this.giftList[index].templateUrl}`
              : `${url}?image=${this.giftList[index].templateExampleUrl}`,
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    checkputn(e, data = "", type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        let row = {
          prizeCount: data,
          price: this.prizeSettingList.price,
          quantityTotal: this.prizeSettingList.quantityTotal,
        };
        if (row.quantityTotal && row.price && row.prizeCount) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            return this.$message.warning("京豆奖品份数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.prizeCount;
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row,type){
      console.log("活动进行中修改奖品数量",row,type);
      if(this.isStartEdit){
        if(row && type == 1){
          if(row.minNum && Number(row.totalAmount) < Number(row.minNum)){
            row.totalAmount = row.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        }else if(row && type == 2){
          if(row.minNum && Number(row.prizeCount) < Number(row.minNum)){
            row.prizeCount = row.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        }else if(type == 'bonusPoints'){
          console.log("this.ruleForm.minNum",this.ruleForm.minNum)
          console.log("this.ruleForm.bonusPoints",this.ruleForm.bonusPoints)
          if(this.ruleForm.minNum && Number(this.ruleForm.bonusPoints) < Number(this.ruleForm.minNum)){
            this.ruleForm.bonusPoints = this.ruleForm.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        }else if(type == 'prizeCount'){
          if(this.ruleForm.minNum && Number(this.ruleForm.prizeCount) < Number(this.ruleForm.minNum)){
            this.ruleForm.prizeCount = this.ruleForm.minNum
            this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
          }
        }
      }
    },
    //清空商品数据
    deleteCoupon() {
      if(this.isStartEdit) return;
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    //选择商品数据
    getTheData(data, prizeType) {
      this.prizeSettingList = {}
      if(data.couponType == 4) {
        this.generalCoupon = JSON.parse(JSON.stringify(data))
      } else {
        this.generalCoupon = { couponType: 0 }
      }
      this.showDialog = false;
      if (this.ruleForm.isCumulativePrize == true) {
        if(data.couponType == 4) {
          this.tableData[this.tableIndex].prizeType = prizeType;
          this.tableData[this.tableIndex].price = data.price;
          this.tableData[this.tableIndex].singleAmount = 1;
          this.tableData[this.tableIndex].title = "优惠券";
          this.tableData[this.tableIndex].assetsId = null;
          this.tableData[this.tableIndex].couponType = data.couponType;
          this.tableData[this.tableIndex].batchKey = data.batchKey;
        } else {
          this.tableData[this.tableIndex].prizeType = prizeType;
          this.tableData[this.tableIndex].price = data.discount || data.singleAmount;
          this.tableData[this.tableIndex].singleAmount = data.singleAmount;
          this.tableData[this.tableIndex].title = data.name || prizeType;
          this.tableData[this.tableIndex].assetsId = Number(data.couponId);
          this.tableData[this.tableIndex].logo = data.logo;
        }
        if(prizeType == 1) {
          if(data.couponType == 4) {
            this.tableData[this.tableIndex].couponType = 4;
          } else {
            this.tableData[this.tableIndex].couponType = 3;
          }
        }
        if (prizeType == 2) {
          this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
        }
        if (prizeType == 10) {
          this.tableData[this.tableIndex].price = data.price;
          this.tableData[this.tableIndex].title = data.itemTitle;
          this.tableData[this.tableIndex].assetsId = data.id;
          this.tableData[this.tableIndex].logo = data.picUrl;
        }
        if(data.couponType == 4){
          this.tableData[this.tableIndex].price = data.discount || data.price;
        }
      } else {
        if(data.couponType == 4) {
          this.prizeSettingList.singleAmount = 1;
          this.prizeSettingList.assetsId = null;
          this.prizeSettingList.prizeType = prizeType;
          this.prizeSettingList.title = "优惠券";
          this.prizeSettingList.price = data.price;
          this.prizeSettingList.batchKey = data.batchKey;
          this.prizeSettingList.couponType = data.couponType;
        } else {
          this.prizeSettingList.singleAmount = Number(data.price)|| 1;
          this.prizeSettingList.assetsId = Number(data.couponId);
          this.prizeSettingList.prizeType = prizeType;
          this.prizeSettingList.logo = data.logo;
          this.prizeSettingList.title = data.name || prizeType;
          this.prizeSettingList.price = data.discount || data.price;
        }
        if(prizeType == 1) {
          if(data.couponType == 4) {
            this.prizeSettingList.couponType = 4;
          } else {
            this.prizeSettingList.couponType = 3;
          }
        }
        if (prizeType == 4) {
          this.prizeSettingList.title = data.discount+"店铺积分";
          this.prizeSettingList.price = data.discount;
          this.prizeSettingList.singleAmount = data.singleAmount;
        } else if (prizeType == 2) {
          this.prizeSettingList.singleAmount = data.singleAmount;
          this.prizeSettingList.couponType = data.couponType;
          this.prizeSettingList.title = prizeType;
          this.prizeSettingList.quantityTotal = data.quantityTotal;
        } else if (prizeType == 10) {
          this.prizeSettingList.singleAmount = data.singleAmount;
          this.prizeSettingList.couponType = data.couponType;
          this.prizeSettingList.title = data.itemTitle;
          this.prizeSettingList.quantityTotal = data.quantityTotal;
          this.prizeSettingList.assetsId = data.id;
          this.prizeSettingList.logo = data.picUrl;
        }
        if (this.localStepNum == 1) {
          const obj = {
            singleAmount: this.prizeSettingList.singleAmount,
            assetsId: this.prizeSettingList.assetsId || null,
            prizeType: this.prizeSettingList.prizeType,
            title: this.prizeSettingList.title,
            price: this.prizeSettingList.price,
            totalAmount: this.awardSettingsLsit[0].totalAmount
          }
          if (obj.prizeType == 3) {
            obj.logo = data.logo
          }
          this.awardSettingsLsit = []
          this.awardSettingsLsit.push(obj)
          this.$forceUpdate()
        }
        this.setPrizeTxt(this.prizeSettingList);
        console.log(this.prizeSettingList, 22222);
      }
    },
    getTheData1(data, prizeType) {
      this.showDialog1 = false;
      let params = {}
      if(data.couponType == 4) {
        params.singleAmount = 1;
        params.assetsId = null;
        params.prizeType = prizeType;
        params.title = "优惠券";
        params.price = data.price;
        params.batchKey = data.batchKey;
        params.couponType = data.couponType;
      } else {
        params.singleAmount = Number(data.price)|| 1;
        params.assetsId = Number(data.couponId);
        params.prizeType = prizeType;
        params.logo = data.logo;
        params.title = data.name || prizeType;
        params.price = data.discount || data.price;
      }
      if(prizeType == 1) {
        if(data.couponType == 4) {
          params.couponType = 4;
        } else {
          params.couponType = 3;
        }
      }
      if (prizeType == 4) {
        params.title = data.discount+"店铺积分";
        params.price = data.discount;
        params.singleAmount = data.singleAmount;
      } else if (prizeType == 2) {
        params.singleAmount = data.singleAmount;
        params.couponType = data.couponType;
        params.title = prizeType;
        params.quantityTotal = data.quantityTotal;
      } else if (prizeType == 10) {
        params.singleAmount = data.singleAmount;
        params.couponType = data.couponType;
        params.title = data.itemTitle;
        params.quantityTotal = data.quantityTotal;
        params.assetsId = data.id;
        params.logo = data.picUrl;
      }
      if (this.localStepNum == 1) {
        const obj = {
          singleAmount: params.singleAmount,
          assetsId: null,
          prizeType: params.prizeType,
          title: params.title,
          price: params.price,
          totalAmount: this.itemArr[this.itemIndex].totalAmount,
          days: this.itemArr[this.itemIndex].days,
        }
        this.itemArr[this.itemIndex].prizeType = obj.prizeType
        this.itemArr[this.itemIndex].title = obj.title
        this.itemArr[this.itemIndex].price = obj.price;
        this.itemArr[this.itemIndex].singleAmount = obj.singleAmount;
        if (prizeType == 3) {
          this.itemArr[this.itemIndex].logo = data.logo;
        }

        // 订单备注开启单独处理
        if (data.prizeRemarkType) {
          this.itemArr[this.itemIndex].prizeRemarkType = data.prizeRemarkType;
          this.itemArr[this.itemIndex].receivePayment = data.receivePayment;
          this.itemArr[this.itemIndex].tradeLimitTime = data.tradeLimitTime;
          this.itemArr[this.itemIndex].tradeLimitTimeUnit = data.tradeLimitTimeUnit;
          this.itemArr[this.itemIndex].itemType = data.itemType;
          this.itemArr[this.itemIndex].tradeFlag = data.tradeFlag;
          this.itemArr[this.itemIndex].content = data.content;

          if (data.itemType) {
            const arr = data.goodsList.map(item => item.wareId)
            this.itemArr[this.itemIndex].numIid = arr.join(",");
          } else {
            this.itemArr[this.itemIndex].numIid = "";
          }
        }
        this.$forceUpdate()
      }
    },
    setPrizeTxt(item) {
      if (item.prizeType == 8) {
        item.prizeTxt = item.price + "元";
      } else if (item.prizeType == 7 || item.prizeType == 6 || item.prizeType == 5) {
        item.prizeTxt = item.price;
      } else {
        if(item.couponType == 4) {
          item.prizeTxt = item.price;
        } else {
          item.prizeTxt = item.singleAmount;
        }
      }
    },
    //模板下一步
    nextStep() {
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
      console.log(this.activeValue, 1111);
      console.log(this.valueRow, 222);
      console.log(this.activityData, 33);
      console.log(this.isSave, 444);
      console.log(this.backgroundOpacity, 5555);
    },
    //开卡礼包
    async nextStepKai(items, type = "1") {
      // console.log(items);
      //新增判断
      // const res = await getValidActivity()
      // if(res.data){
      //   const message = '当前正在进行【'+ res.data[0].activityName + '】活动'+res.data[0].activityStartTime+'~'+ res.data[0].activityEndTime + '，必须结束后才能新建！'
      //   this.$message.warning(message)
      //   return
      // }

      if (type == "1") {
        const res = await getValidActivity();
        // if(res.data){
        //   const message = '当前正在进行【'+ res.data[0].activityName + '】活动'+res.data[0].activityStartTime+'~'+ res.data[0].activityEndTime + '，必须结束后才能新建！'
        //   this.$message.warning(message)
        //   return
        // }
        // 进来  会员和非会员 默认为同一模板认
        this.giftID = items.id;
        this.memberGiftTemplateId = items.id;
        this.templateUrlimg = items.templateUrl;
        this.templateUrlimg1 = items.templateUrl;
        this.localStep = 1;
        this.$emit("titopName", this.activityData.name, true);
      }
      // 1 店铺积分  2 京豆  3  京券  4  东券
      this.giftPrizeType = items.prizeType ? items.prizeType.split(",") : [];
      this.giftPrizeType.forEach((info) => {
        this.libaoList.forEach((ele) => {
          if (info == 1) {
            if (ele.prizeType == "6") {
              ele.giftFalse = true;
            }
          }
          if (info == 2) {
            if (ele.prizeType == "4") {
              ele.giftFalse = true;
            }
          }
          if (info == 3) {
            if (ele.prizeType == "0") {
              ele.giftFalse = true;
            }
          }
          if (info == 4) {
            if (ele.prizeType == "1") {
              ele.giftFalse = true;
            }
          }
        });
      });

      // 0 无奖项  1 有奖项
      if (items.giftPrizeType == 0) {
        this.ruleForm.isHavePrizes = "2";
        this.giftYouDisabled = true;
        //无奖项
        this.ruleForm.prizes = [];
        this.ruleForm.buttonText = "";
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            item.priceName = "每份店铺积分：0";
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
      } else {
        this.ruleForm.isHavePrizes = "1";
        this.giftWuDisabled = true;
        // 有奖项
        this.ruleForm.jumpLink = "";
        this.ruleForm.isMemberGiftCheck = false;
        this.ruleForm.memberGiftJumpLink = "";
        const num = this.giftPrizeType.indexOf("1");
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            if (num != -1) {
              item.backAction = true;
              item.totalAmount = 1;
              item.singleAmount = "1";
              item.priceName = "每份店铺积分：1";
            } else {
              item.priceName = "每份店铺积分：0";
            }
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
        if (num != -1) {
          this.ruleForm.prizes = [
            {
              price: 1,
              prizeType: 6,
              singleAmount: 1,
              totalAmount: this.ruleForm.sendCount,
              title: `1积分`,
            },
          ];
        }
      }

      // this.localStep = 1;
      // this.$emit('titopName',this.activityData.name,true)
    },
    removeEmptyObjects(arr) {
      console.log("进来处理对象")
      return arr.filter(function(item) {
        return Object.keys(item).length > 0;
      });
    },
    //弹框确认
    handleDialogCloseAnoth() {
      this.ruleForm.activityStartTime = this.activityTimeValue.length
        ? this.activityTimeValue[0]
        : "";
        this.ruleForm.activityEndTime = this.activityTimeValue.length
        ? this.activityTimeValue[1]
        : "";
      //日历签到
      let everyDay = {
        activityName: this.ruleForm.activityName, //活动名称
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级
        condFollow: this.ruleForm.isFollow == true ? 1 : 0, //参与条件
        endTime: this.ruleForm.activityEndTime, //活动结束时间
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.crowdList.join(","),
        isExposureItem: this.ruleForm.exposureSwitch == false ? 0 : 1, //是否曝光商品：0否,1是
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
        points: Number(this.ruleForm.inputprize), //单次奖励积分
        priceType: this.ruleForm.radio, //曝光商品价格显示：0显示淘宝价，1显示促销价
        pointActivityPrizeDTO: {
          //选择奖品数据
          id: this.prizeSettingList.id,
          price: this.prizeSettingList.price,
          title: this.prizeSettingList.title,
          assetsId: this.prizeSettingList.assetsId,
          prizeType: this.prizeSettingList.prizeType,
          logo: this.prizeSettingList.logo,
          couponType: this.prizeSettingList.couponType,
        },
        ruleDTO: {
          //规则拓展信息
          continueRule: this.itemArr,
          requestFollow: this.ruleForm.isFollow, //是否关注
          startTime: this.ruleForm.startTime,
          prizeCount: Number(this.ruleForm.prizeCount),
        },
        ruleDescription: this.ruleForm.activityRulesText, //规则拓展信息
        startTime: this.ruleForm.activityStartTime, //活动开始时间
      };
      if(this.activityData.id == 2){
        if(!everyDay.allowLevel)return this.$message.warning('请选择活动对象')
        if(!everyDay.pointActivityPrizeDTO.prizeType)return this.$message.warning('请选择奖品')
      }
      if(this.activityData.id == 6){
        if(this.ruleForm.information.length ==0)return this.$message.warning('请勾选完善资料信息')
      }
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.activityStartTime,
        endTime: this.ruleForm.activityEndTime,
        activityObject: this.ruleForm.activityObject,
        membershipTime:this.ruleForm.membershipTime,
        newOldCustomer: this.ruleForm.newOldCustomer,
        seniorGroupId: this.crowdList.join(","),
        activityType: this.activityData.id, //活动类型  13: 开卡礼包 14: 店铺礼包
        giftTemplateId: this.giftID, //礼包模板id
        isExposureItem: this.ruleForm.radio, //是否添加曝光商品 0 否 1 是
        ruleDTO: {
          requestFollow: this.ruleForm.requestFollow == 1 ? true : false, //是否需要关注店铺
          buttonText: this.ruleForm.buttonText,
          isOutClose: this.ruleForm.isOutClose == 1 ? true : false, //勾选奖品发完是否自动结束活动
          isHavePrizes: this.ruleForm.isHavePrizes == 1 ? true : false, //是否有奖项
          sendCount: this.ruleForm.sendCount,
          jumpLink: this.ruleForm.jumpLink,
          isMemberGiftCheck: this.ruleForm.isMemberGiftCheck,
          memberGiftJumpLink: this.ruleForm.memberGiftJumpLink,
          modelIds: this.ruleForm.modelIds, //人群
        }, //活动名称
        prizes: this.ruleForm.prizes,
        itemList: this.itemListFor.map((item) => {
          return {
            logo: item.logo,
            price: item.price,
            title: item.title,
            skuId: item.skuId,
            wareId: item.numIid,
          };
        }), //曝光商品集合
      };
      if (this.ruleForm.isHavePrizes == "2") {
        cardParams.memberGiftTemplateId = this.memberGiftTemplateId;
      }
      //人群处理
      if (this.activityData.id == 13 || this.activityData.id == 14) {
        if (this.ruleForm.modelIds == this.personLab.customizeList[1].labelId || this.ruleForm.modelIds == this.personLab.recommendList[3].labelId) {
          const str1 = this.ruleForm.vermicelliVal.join("_");
          const str2 = this.ruleForm.starVal.join("_");
          if ((this.ruleForm.modelIds == "v1_no_f" && !str1) || (this.ruleForm.modelIds == "v1_customer" && !str2)) {
            return this.$message.warning("请选择目标人群");
          }
          if (str1) {
            cardParams.ruleDTO.modelIds = `${this.ruleForm.modelIds}:${str1}`;
          }
          if (str2) {
            cardParams.ruleDTO.modelIds = `${this.ruleForm.modelIds}:${str2}`;
          }
        }
        if (this.ruleForm.modelIds == "v1_new_p" || this.ruleForm.modelIds == "v1_plus" || this.ruleForm.modelIds == "v1_new_fans") {
          cardParams.ruleDTO.modelIds = `${this.ruleForm.modelIds}:0`;
        }
      }

      //编辑回显
      this.momentValue = everyDay;
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            // if (obj.wareId == a[i]) {
            //   b.push({
            //     logo: obj.logo,
            //     price: obj.price,
            //     title: obj.title,
            //     wareId: obj.wareId,
            //   });
            // }
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
                wareId: obj.numIid,
              });
            }
          });
        }
        everyDay.itemList = b;
      }
      //活动名称的限制
      if (!this.ruleForm.activityName || this.ruleForm.activityName.length == 0) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.activityStartTime || !this.ruleForm.activityEndTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if (this.activityData.id == 13 || this.activityData.id == 14) {
        //选择目标人群
        if (!this.ruleForm.modelIds) {
          this.$message.warning("请选择目标人群");
          return;
        }
        //发送人数
        if (!this.ruleForm.sendCount) {
          this.$message.warning("请输入发送人数");
          return;
        }
        // 礼包样式:
        if (this.ruleForm.isHavePrizes == "1") {
          if (this.ruleForm.prizes.length == 0) {
            this.$message.warning("请输入选择礼包样式");
            return;
          }
        }
        //礼包确认按钮文案
        if (!this.ruleForm.buttonText && this.ruleForm.isHavePrizes == 1) {
          this.$message.warning("请输入礼包确认按钮文案");
          return;
        }
      }

      if (this.activityData.id != 13 && this.activityData.id != 14) {
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }
      }
      console.log(this.activityData);

      // 增加节流
      if (this.isClick) {
        return
      }
      this.isClick = true;
      setTimeout(() => {
        this.isClick = false
      }, 1000)

      //判断勾选提示后即可调取接口
      if (this.checked == true) {
        if (this.activityData.id == 13) {
          if (this.valueRow) {
            //修改礼包 开卡  店铺
            editShopGift({ ...cardParams, id: this.valueRow.id }).then((res) => {
              if (res.code == 1) {
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            //创建礼包 开卡  店铺
            createShopGift(cardParams).then((res) => {
              if (res.code == 1) {
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else if (this.activityData.id == 14) {
          if (this.valueRow) {
            //修改礼包 开卡  店铺
            editShopGift({ ...cardParams, id: this.valueRow.id }).then((res) => {
              if (res.code == 1) {
                this.$router.push({ path: "activeList" });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            //创建礼包 开卡  店铺
            createShopGift(cardParams).then((res) => {
              if (res.code == 1) {
                this.$emit("saveEdit");
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else if (this.activityData.id == 1) {
          console.log(this.activeValue);
          this.isPack = true
          if (this.activeValue == 1 && !this.isCopy) {
            everyDay.pointActivityId = this.valueRow.id;
            if(this.ruleForm.prizeSetOne) {
              this.itemArr.forEach(item=>{
                if(!item.days) {
                  this.isPack = false
                }
                item.signIsSequence = 1
                item.signSequenceTimes = item.days ? item.days : undefined
              })
            }else {
              this.itemArr = []
            }
            everyDay.pointActivityPrizeDTOList = [...this.awardSettingsLsit, ...this.itemArr]

            everyDay.points = 1
            everyDay.ruleDTO.continueRule = null
            everyDay.ruleDTO.pointActivityPrizeDTOList = everyDay.pointActivityPrizeDTOList
            if(!this.isPack) {
              this.$message.error("连续签到天数不能为空")
              return
            }
            editIntegral(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            everyDay.templateId = this.activityData.templateId
            if (this.activityData.id == 1) {
              let arr = []
              const length = this.awardSettingsLsit.length + this.itemArr.length
              for(let i = 0; i < length; i++) {
                let obj = {}
                if(i == 0) {
                  obj = this.awardSettingsLsit[0]
                  obj.signIsSequence = 0
                } else {
                  obj = JSON.parse(JSON.stringify(this.itemArr[i - 1]))
                  if(this.ruleForm.prizeSetOne) {
                    obj.signIsSequence = 1
                    obj.signSequenceTimes = obj.days
                    if(!obj.signSequenceTimes) {
                      this.isPack = false
                    }
                  }
                  if(obj.prizeRemarkType) {
                    obj.pointActivityPrizeRemark = {}
                    obj.pointActivityPrizeRemark.receivePayment = obj.receivePayment;
                    obj.pointActivityPrizeRemark.tradeLimitTime = obj.tradeLimitTime;
                    obj.pointActivityPrizeRemark.tradeLimitTimeUnit = obj.tradeLimitTimeUnit;
                    obj.pointActivityPrizeRemark.itemType = obj.itemType;
                    obj.pointActivityPrizeRemark.tradeFlag = obj.tradeFlag;
                    obj.pointActivityPrizeRemark.content = obj.content;
                    obj.pointActivityPrizeRemark.numIid = obj.numIid;
                    delete obj.receivePayment;
                    delete obj.tradeLimitTime;
                    delete obj.tradeLimitTimeUnit;
                    delete obj.itemType;
                    delete obj.tradeFlag;
                    delete obj.content;
                    delete obj.numIid;
                  }
                  delete obj.continueSignPoints
                  delete obj.days
                }
                arr.push(obj)
              }
              everyDay.pointActivityPrizeDTOList = arr
              everyDay.points = 1
              everyDay.ruleDTO.continueRule = null
              everyDay.ruleDTO.pointActivityPrizeDTOList =arr
            }
            if(!this.isPack) {
              this.$message.error("连续签到天数不能为空")
              return
            }
            everyDay.ruleDTO.pointActivityPrizeDTOList = this.removeEmptyObjects(everyDay.ruleDTO.pointActivityPrizeDTOList )
            everyDay.pointActivityPrizeDTOList = this.removeEmptyObjects(everyDay.ruleDTO.pointActivityPrizeDTOList )
            creatIntegral(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        } else if (this.activityData.name == "每日抢好礼") {
          if(this.generalCoupon.couponType == 4) {
            delete everyDay.pointActivityPrizeDTO.uuid
            everyDay.pointActivityPrizeDTO.assetsId = null
            everyDay.pointActivityPrizeDTO.couponType = 4
            everyDay.pointActivityPrizeDTO.prizeType = 1
            everyDay.pointActivityPrizeDTO.batchKey = this.generalCoupon.batchKey
            everyDay.pointActivityPrizeDTO.price = this.generalCoupon.price
            everyDay.pointActivityPrizeDTO.title = "优惠券"
          }
          //每日抢好礼
          if (this.activeValue == 3  && !this.isCopy) {
            everyDay.pointActivityId = this.valueRow.id;
            editPrize(everyDay).then((res) => {
              if (res.code == 1) {
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            creatPrize(everyDay).then((res) => {
              if (res.code == 1) {
                // this.$emit("saveEdit");
                this.$router.push({ path: "activeList" });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else if (this.activityData.name == "关注店铺有礼") {
          everyDay.ruleDTO = {};
          everyDay.points = this.ruleForm.bonusPoints;
          if (this.activeValue == 4 && !this.isCopy) {
            everyDay.pointActivityId = this.valueRow.id;
            editfocusStores(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            focusStores(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        } else if (this.activityData.name == "邀请开卡有礼") {
          everyDay.ruleDTO = {};
          // 接口需要，points固定传个正数
          everyDay.points = 1;

          everyDay.ruleDTO.maxInviteNum = this.ruleForm.peopleCount;
          everyDay.ruleDTO.isCumulativePrize = this.ruleForm.isCumulativePrize;
          delete everyDay.pointActivityPrizeDTO;
          // 梯度奖励
          if (this.ruleForm.isCumulativePrize) {
            everyDay.ruleDTO.cumulativePrizes = this.tableData.map((item) => {
              let prize = {
                id:item.id,
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                singleAmount: item.singleAmount,
                totalAmount: item.prizeCount,
              };
              if (prize.prizeType == 3 || prize.prizeType == 10) {
                prize.logo = item.logo;
              }
              if (prize.prizeType != 2 && prize.prizeType != 4) {
                console.log(item.discount);
                prize.price = item.discount;
              }
              return {
                cumulativeNum: item.peopleCount,
                cumulativePrizeDTO: prize,
              };
            });
            everyDay.ruleDTO.maxInviteNum = this.tableData[this.tableData.length - 1].peopleCount;
            console.log(everyDay.ruleDTO.cumulativePrizes);
          } else {
            let prize = {
              id:this.prizeSettingList.id,
              title: this.prizeSettingList.title,
              assetsId: this.prizeSettingList.assetsId,
              prizeType: this.prizeSettingList.prizeType,
              logo: this.prizeSettingList.logo,
              singleAmount: this.prizeSettingList.singleAmount,
              totalAmount: this.ruleForm.prizeCount,
            };
            if (prize.prizeType == 4) {
              prize.logo = this.prizeSettingList.logo;
            }
            if (prize.prizeType != 2 && prize.prizeType != 4) {
              prize.price = this.prizeSettingList.discount;
            }
            everyDay.ruleDTO.cumulativePrizes = [
              {
                cumulativeNum: 1,
                cumulativePrizeDTO: prize,
              },
            ];
            console.log(this.prizeSettingList, 123);
          }

          if (this.activeValue == 5) {
            everyDay.pointActivityId = this.valueRow.id;
            editInvite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            invite(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        } else if (this.activityData.name == "邀请关注店铺有礼") {
          everyDay.ruleDTO.isShowRemanentAmount = this.isShowRemanentAmount
          everyDay.ruleDTO.maxInviteNum = Number(this.ruleForm.peopleCount);
          everyDay.ruleDTO.isCumulativePrize = this.ruleForm.isCumulativePrize;
          everyDay.points = 1;
          everyDay.ruleDTO.filterInviteOption = this.filterInviteOption
          // 梯度奖励
          if (this.ruleForm.isCumulativePrize) {
            console.log("this.tableData",this.tableData)
            everyDay.ruleDTO.cumulativePrizes = this.tableData.map((item) => {
              let prize = {
                id:item.id,
                title: item.title,
                assetsId: item.assetsId,
                prizeType: item.prizeType,
                singleAmount: item.singleAmount,
                totalAmount:Number(item.prizeCount)
              };
              if (item.couponType == 4) {
                prize.couponType = 4;
                prize.batchKey = item.batchKey;
              }
              if(item.prizeType == 1) {
                if(item.couponType == 4) {
                  prize.couponType = 4;
                } else {
                  prize.couponType = 3;
                }
              }
              if (prize.prizeType == 3 || prize.prizeType == 10) {
                prize.logo = item.logo;
              }
              if (prize.prizeType != 2 && prize.prizeType != 4) {
                console.log(item.price);
                prize.price = item.price;
              }
              return {
                cumulativeNum: item.peopleCount,
                cumulativePrizeDTO: prize,
              };
            });
            everyDay.ruleDTO.maxInviteNum = this.tableData[this.tableData.length - 1].peopleCount;
            console.log(everyDay.ruleDTO.cumulativePrizes);
          } else {
            console.log("this.prizeSettingList",this.prizeSettingList)
            let prize = {
              id:this.prizeSettingList.id,
              title: this.prizeSettingList.title,
              assetsId: this.prizeSettingList.assetsId,
              prizeType: this.prizeSettingList.prizeType,
              logo: this.prizeSettingList.logo,
              singleAmount: this.prizeSettingList.singleAmount,
              totalAmount: this.ruleForm.prizeCount,
            };
            if(prize.prizeType == 1) {
              if(this.generalCoupon.couponType == 4) {
                prize.couponType = 4;
                prize.batchKey = this.generalCoupon.batchKey
                everyDay.pointActivityPrizeDTO.batchKey = this.generalCoupon.batchKey
              } else {
                prize.couponType = 3;
              }
            }
            if (prize.prizeType == 3) {
              prize.logo = this.prizeSettingList.logo;
            }
            if (prize.prizeType != 2 && prize.prizeType != 4) {
              prize.price = this.prizeSettingList.price;
            }
            everyDay.points = Number(this.prizeSettingList.price);
            // everyDay.pointActivityPrizeDTO.totalAmount = this.ruleForm.prizeSetOne ? this.ruleForm.prizeCount : undefined
            everyDay.pointActivityPrizeDTO.totalAmount = this.ruleForm.prizeCount || 0
            everyDay.ruleDTO.cumulativePrizes = [
              {
                cumulativeNum:1,
                cumulativePrizeDTO: prize,
              },
            ];
            console.log( everyDay.ruleDTO.cumulativePrizes, 1234);
          }
          if (this.activeValue == 6 && !this.isCopy) {
            everyDay.pointActivityId = this.valueRow.id;
            if(everyDay.pointActivityPrizeDTO.prizeType != 4){
              everyDay.points = 1
            }
            editfollow(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            if(everyDay.pointActivityPrizeDTO.prizeType != 4){
              everyDay.points = 1
            }
            everyDay.pointActivityPrizeDTO.singleAmount=this.prizeSettingList.singleAmount
            everyDay.pointActivityPrizeDTO.totalAmount=this.ruleForm.prizeCount
            let postData = JSON.parse(JSON.stringify(everyDay))
            follow(postData)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        } else if (this.activityData.name == "完善信息有礼") {
          if(this.ruleForm.information.length == 0) return this.$message.warning('请选择完善资料信息')
          this.testInfo = [];
          this.itemArrOne.forEach((i) => {
            this.testInfo.push({
              type: i.informationmationSelect,
              name: i.informationmationOne,
              selected: i.selected
            });
          });
          everyDay.ruleDTO = {};
          everyDay.ruleDTO.infoNames = this.ruleForm.information;
          everyDay.ruleDTO.exclusion = this.ruleForm.exclusion ? 1 : 0;
          everyDay.ruleDTO.staticInfoNames = this.testInfo;
          everyDay.points = this.ruleForm.bonusPoints;
          everyDay.ruleDTO.privacySelected = this.ruleForm.privacySelected;
          if (this.ruleForm.privacySelected) {
            if(!this.ruleForm.improveInformationPrivacyDTO.privacyTitle || !this.ruleForm.improveInformationPrivacyDTO.privacyDescription) {
              this.$message.warning("请输入完整的隐私政策内容")
              return 
            }
          }
          everyDay.ruleDTO.improveInformationPrivacyDTO = {
            privacyTitle: this.ruleForm.improveInformationPrivacyDTO.privacyTitle,
            isNecessary: this.ruleForm.improveInformationPrivacyDTO.isNecessary ? 1 : 0,
            privacyDescription: this.ruleForm.improveInformationPrivacyDTO.privacyDescription,
          };
          if (this.activeValue == 7 && !this.isCopy) {
            everyDay.pointActivityId = this.valueRow.id;
            editInformationAa(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          } else {
            information(everyDay)
              .then((res) => {
                if (res.code == 1) {
                  // this.$emit("saveEdit");
                  this.$router.push({ path: "activeList" });
                  this.$message.success(res.message);
                } else {
                  this.$message.error(res.message);
                }
              })
              .catch(() => {});
          }
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = null;
      this.ruleForm.activityEndTime = null;
    },
    //删除
    delec(item,index) {
      let i = -1
      this.mainImagelist.forEach((items,index1)=>{
        if(items.skuId == item.skuId)i = index1
      })
      console.log(i,55555);
      if(i != -1){
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist
      }
      console.log(this.mainImagelist, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      if(this.isStartEdit) return;
      this.itemArrOne.splice(index, 1);
      this.ruleForm.informationOne.splice(index,1)
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      console.log("this.mainImagelist)", this.mainImagelist);
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
      console.log("this.mainImagelist)", arr);
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      if(this.isStartEdit) return;
      this.isShowRemarkOrder = false;
      console.log(scope.$index, 6666);
      this.generalCoupon = { couponType: 0 }
      this.JingdouCount.prizeCount = this.ruleForm.prizeCount;
      if (scope.$index || scope.$index == 0) {
        this.tableIndex = scope.$index;
        if (this.tableData[scope.$index].prizeType == 3) {
          this.clickActual = true;
        }
      }
      if (this.isCumulativePrize) {
        this.JingdouCount = this.tableData[this.tableIndex];
      } else {
        this.JingdouCount = this.prizeSettingList;
      }


      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
        if (scope && (scope.$index || scope.$index == 0)) {
          this.$refs.selectProduct.physicalGift(scope.row)
        }else{
          this.$refs.selectProduct.physicalGift(this.prizeSettingList)
        }
      });
    },
    centerVis1(scope) {
      if(this.isStartEdit) return;
      this.isShowRemarkOrder = true;
      if (scope.$index || scope.$index == 0) {
        this.itemIndex = scope.$index;
      }
      this.showDialog1 = true;
      this.$nextTick(() => {
        this.$refs.selectProduct1.openDialog();
        this.$refs.selectProduct.physicalGift(scope.row)
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
      if(val&&this.itemArr.length==0) {
        this.addCondition()
      }
    },
    //连续签到删除
    deletea(index) {
      if(this.isStartEdit) return;
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      if(this.isStartEdit) return;
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      if(this.isStartEdit) return;
      if (this.isStartEdit) return;
      let valueParm = {
        informationmationOne: "",
        informationmationSelect: 1,
        selected: 1,
      };
      this.ruleForm.informationOne.push(this.itemArrOne.length)
      this.itemArrOne.push(valueParm);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0]= this.isStartEditTime
      }
      this.ruleForm.activityStartTime = this.activityTimeValue[0];
      this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let invalidateDate = new Date(this.$store.state.loginUserInfo.expiredIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.activityStartTime.substring(0, 10);
      daysEnd = this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime != "" && this.ruleForm.activityStartTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days < 3 && !this.backgroundOpacity) {
          this.$message.warning("活动间隔最少为3天！");
          this.activityTimeValue[1] = "";
          this.ruleForm.activityEndTime = null;
          this.timeOut = 0;
          this.timeDay = 0;
          return;
        }

        this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.activityEndTime).getTime() - new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = null;
        return;
      }
      if (this.activityData.id == 13 || this.activityData.id == 14) {
        if ((start - nowTime) / 1000 / 60 < 20) {
          if (this.activeValue) {
            this.disableTime = true;
          } else {
            this.$message.warning("活动时间开始时间要大于当前时间的20分钟");
          }
        }
      } else {
        if ((start - nowTime) / 1000 / 60 < 5) {
          if (this.activeValue) {
            this.disableTime = true;
          } else {
            this.$message.warning("活动时间开始时间要大于当前时间的5分钟");
          }
        }
      }

      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.activityEndTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
      }
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      let state = true;
      if (this.ruleForm.activityObject == 2 && !this.crowdList.length) {
        return this.$message.error("请完善活动对象信息！");
      }
      if (this.ruleForm.isCumulativePrize) {
        let arr = this.tableData.map((i) => {
          return i.peopleCount;
        });
        if (arr.indexOf("") != -1) {
          return this.$message.error("邀请人数不可为空");
        }
        let copyArr = JSON.parse(JSON.stringify(arr)).sort((a,b)=>{return a-b})
        for(let i=0;i<arr.length;i++) {
          if(arr[i] != copyArr[i]) {
            state = false
          }
        }
        if (!state) {
          return this.$message.error("邀请人数梯度不可大于上一个梯度1");
        }
      }
      this.joinBlackList = true;
    },
    // 下一步
    resetForm() {
      this.joinBlackList = true;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsState = false;
        return;
      }
    },
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "",
        text9 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.activityStartTime && this.ruleForm.activityEndTime) {
        text2 = "活动时间：" + this.ruleForm.activityStartTime + "~" + this.ruleForm.activityEndTime;
      }
      //参与对象
      if (this.ruleForm.partner.length > 0) {
        let levelText = [];
        this.ruleForm.partner.forEach((item, index) => {
          if (item == -1) {
            item = "全部";
          } else if (item == 0) {
            item = "非会员";
          } else {
            this.levelList.forEach((it, index) => {
              if (index + 1 == item) {
                item = it;
              }
            });
          }
          levelText.push(item);
        });
        if (this.activityData.name == "邀请开卡有礼") {
          text4 = "";
        } else if (this.activityData.name == "邀请关注店铺有礼") {
          text4 = "";
        } else {
          text4 = "活动参与对象：" + levelText.splice(",");
        }
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      //活动条件
      if (this.ruleForm.isFollow == true) {
        text5 = "活动条件：" + "关注店铺后方可参与活动";
      }
      //奖品设置
      if (this.activityData.name == "签到领好礼" || this.activityData.name == "签到赢好礼") {
        if (this.awardSettingsLsit[0].title != "" && (this.ruleForm.singScore == false || !this.ruleForm.singScore)) {
          text6 = "奖品设置：" + "每日签到赠送" + this.awardSettingsLsit[0].title;
        } else if (this.awardSettingsLsit[0].title == "" && !this.ruleForm.singScore) {
          text6 = "";
        } else {
          text6 = "奖品设置：" + "每日签到送" + this.awardSettingsLsit[0].title + ";";
        }
        if (this.ruleForm.prizeSetOne && this.itemArr.length) {
          let namell = "";
          this.itemArr.forEach((item, index) => {
            text6 += namell + " 连续签到" + item.days + "天" + "," + "赠送" + item.title + ";";
          });
          text6 = text6.substring(0, text6.length - 1);
        }
      } else if (this.activityData.name == "关注店铺有礼" || this.activityData.name == "完善信息有礼") {
        text6 = "奖品设置：" + "赠送" + this.ruleForm.bonusPoints + "积分";
      } else if (this.activityData.name == "邀请开卡有礼") {
        console.log(this.prizeSettingList.prizeType);
        if (!this.ruleForm.isCumulativePrize) {
          let priceText = this.prizeSettingList.discount + prizeName[this.prizeSettingList.prizeType];
          if (this.prizeSettingList.prizeType == 3) {
            priceText = this.prizeSettingList.title;
          }
          text6 =
            "奖品设置：" + "每邀请一人获得" + priceText + "," + "活动期间最多邀请" + this.ruleForm.peopleCount + "人" + "," + "超出人数不再获得奖励";
        } else {
          console.log();
        }
      } else if (this.activityData.name == "邀请关注店铺有礼") {
        if (!this.ruleForm.isCumulativePrize) {
          console.log('222222');
          let prizeText = this.prizeSettingList.singleAmount + prizeName[this.prizeSettingList.prizeType];
          if (this.prizeSettingList.prizeType == 3) {
            prizeText = this.prizeSettingList.title;
          } else if(this.prizeSettingList.prizeType == 1) {
            prizeText = this.prizeSettingList.price + "元优惠券";
          } else {
            prizeText = this.prizeSettingList.prizeTxt + prizeName[this.prizeSettingList.prizeType];
          }
          text6 = "奖品设置：" + "每邀请一人可获得" + prizeText + ",";
          if (this.ruleForm.peopleCount) {
            text6 += "活动期间最多邀请" + this.ruleForm.peopleCount + "人" + "," + "超出人数不再获得奖励";
          }
        }else {
        let textArr = this.tableData.map((i) => {
            console.log(i,'255588')
            let prizeText = i.prizeType == 3 ? i.title : i.price + "" + prizeName[i.prizeType];
            if(i.prizeType == 1) {
              prizeText = i.price + "元优惠券"
            }
            console.log(i,'6666666')
            let str = `邀请${i.peopleCount}人可获得${prizeText}`;
            return str;
          });
          console.log(textArr);
          text6 = "奖品设置：" + textArr.join("，") + "，超出人数不再获得奖励";}
      text7 = "分享给好友后，需要好友点击进入并关注店铺才算邀请成功";
      text8 = "奖品数量有限，先到先得";
      text9 = '如果被邀请人已经是店铺粉丝，则不计入邀请关注成功人数'
    }
      let levetList = [];
      let levetListOne = [];
      let levetListTwo = "";
      let levetListThree = "";
      this.ruleForm.information.forEach((o, x) => {
        if (o == -1) {
          o = "全部";
        }
        levetListOne.push(o);
      });
      this.itemArrOne.forEach((v, i) => {
        levetList.push(
          {
            type: v.informationmationSelect,
            name: v.informationmationOne
          }
        );
      });
      levetListTwo = levetListOne.join(",");
      // levetListThree = levetList.join(",");
      levetList.forEach((item)=>{
        levetListThree += (item.type==1 ? "文本：" : "图片：") + item.name +  "，"
      });
      levetListThree = levetListThree.substring(0,levetListThree.length-1)
      if (levetListTwo.length != "" && levetListThree.length == 1) {
        levetListThree = "";
      }
      if (levetListTwo.length != "" && levetListThree.length > 1) {
        levetListTwo = levetListOne.join(",") + ",";
      }
      if (this.ruleForm.startTime) {
        text7 = "每日开抢时间:" + this.ruleForm.startTime;
      }
      if (this.ruleForm.prizeCount && !this.activityData.name == "邀请关注店铺有礼") {
        text8 = "奖品份数：每日共赠送" + this.ruleForm.prizeCount + "份奖品，每人每日限领一份奖品，先到先得";
      }
      //完善资料信息
      if (this.activityData.name == "完善信息有礼") {
        text8 = "完善资料信息:" + levetListTwo + levetListThree;
      }
      let Arr1 = [text1, text2, text3, text4,text34, text5, text6, text7, text8, text9];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.activityRulesText = newText;
    },
    // 礼包点击
    handleClickPoint(item, i) {
      console.log("1111", item, i);
      this.currtIndex = i;
      this.libaoItem = item;
      this.JingdouCount.prizeCount = this.ruleForm.sendCount;
      this.dialogPrize = true;
    },
    // 移除
    handleRemovePoint(item, i) {
      console.log(item, i);
      this.libaoList[i].backAction = false;
      // item.singleAmount = "";
      this.libaoList[i].singleAmount = "";
      if (item.assetsId) {
        this.libaoList[i].assetsId = "";
      }
      if (item.prizeType == 6) {
        this.libaoList[i].priceName = "每份店铺积分：0";
      }
      if (item.prizeType == 4) {
        this.libaoList[i].priceName = "每份京豆额：0";
      }
      if (item.prizeType == 1) {
        this.libaoList[i].priceName = "0优惠券";
      }
      if (item.prizeType == 0) {
        this.libaoList[i].priceName = "0优惠券";
      }
      let num = -1;
      this.ruleForm.prizes.forEach((ele, index) => {
        if (ele.prizeType == item.prizeType) {
          num = index;
        }
      });
      console.log(num, 2222);
      if (num != -1) {
        this.ruleForm.prizes.splice(num, 1);
      }
      console.log(this.ruleForm.prizes);
    },
    // 多选
    handleCheckedStarChange(val) {
      console.log(val);
      const data = this.personLab.recommendList[this.personLab.recommendList.length - 1].labelVal.map((i) => i.level);
      this.ruleForm.starVal = val ? data : [];
      this.starCheckAll = val;
    },
    handleCheckedChange(val) {
      const data = this.personLab.customizeList[this.personLab.customizeList.length - 1].labelVal.map((i) => i.level);
      this.ruleForm.vermicelliVal = val ? data : [];
      this.verCheckAll = val;
    },
    handleChang() {
      const num1 = this.personLab.customizeList[this.personLab.customizeList.length - 1].labelVal.length;
      const num2 = this.personLab.recommendList[this.personLab.recommendList.length - 1].labelVal.length;
      if (this.ruleForm.vermicelliVal.length == num1) {
        this.verCheckAll = true;
      } else {
        if (this.verCheckAll) {
          this.verCheckAll = false;
        }
      }
      if (this.ruleForm.starVal.length == num2) {
        this.starCheckAll = true;
      } else {
        if (this.starCheckAll) {
          this.starCheckAll = false;
        }
      }
    },
    // 礼包奖项
    changeHavePrizes() {
      if (this.ruleForm.isHavePrizes == 1) {
        this.ruleForm.jumpLink = "";
        this.ruleForm.isMemberGiftCheck = false;
        this.ruleForm.memberGiftJumpLink = "";
        console.log(this.giftPrizeType);
        const num = this.giftPrizeType.indexOf("1");
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            if (num != -1) {
              item.backAction = true;
              item.totalAmount = 1;
              item.singleAmount = "1";
              item.priceName = "每份店铺积分：1";
            } else {
              item.priceName = "每份店铺积分：0";
            }
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
        if (num != -1) {
          this.ruleForm.prizes = [
            {
              price: 1,
              prizeType: 6,
              singleAmount: 1,
              totalAmount: this.ruleForm.sendCount,
              title: `1积分`,
            },
          ];
          console.log(this.ruleForm.prizes);
        }
      } else {
        this.ruleForm.prizes = [];
        this.ruleForm.buttonText = "";
        this.libaoList.forEach((item) => {
          item.backAction = false;
          item.singleAmount = "";
          if (item.assetsId) {
            item.assetsId = "";
          }
          if (item.prizeType == 6) {
            item.priceName = "每份店铺积分：0";
          }
          if (item.prizeType == 4) {
            item.priceName = "每份京豆额：0";
          }
          if (item.prizeType == 1) {
            item.priceName = "0优惠券";
          }
          if (item.prizeType == 0) {
            item.priceName = "0优惠券";
          }
        });
      }
    },
    //单选处理
    radioChange(val) {
      console.log(val);
      // 选中未关注店铺 启用改单选对应的多选 并禁用其他多选
      if (val == "v1_no_f") {
        this.ruleForm.starVal = [];
        this.disableVF = false;
        this.disableCUS = true;
        this.starCheckAll = false;
      } else if (val == "v1_customer") {
        // 选中店铺店铺会员 启用改单选对应的多选 并禁用其他多选
        this.disableCUS = false;
        this.disableVF = true;
        this.ruleForm.vermicelliVal = [];
        this.verCheckAll = false;
      } else {
        this.ruleForm.starVal = [];
        this.ruleForm.vermicelliVal = [];
        this.verCheckAll = false;
        this.starCheckAll = false;
        this.disableVF = true;
        this.disableCUS = true;
      }
    },
    //发送人数
    handleSendCount() {
      if (this.ruleForm.prizes.length > 0) {
        this.ruleForm.prizes.forEach((item) => {
          item.totalAmount = this.ruleForm.sendCount;
        });
      }
    },
    // 接收礼包样式弹窗
    closePrize(val, item) {
      console.log(item);
      this.dialogPrize = false;
      if (val) {
        // 、、 京券
        if (item.prizeType == "0") {
          let params = {
            assetsId: item.couponId,
            price: item.discount, //满100减10   填10
            prizeType: item.prizeType,
            singleAmount: 1, // 使用条件 默认为1
            totalAmount: this.ruleForm.sendCount,
            title: `${item.name}`,
            quota: item.quota, //满100减10   填100
          };
          this.libaoList[this.currtIndex].priceName = item.discount + "元优惠券";
          this.libaoList[this.currtIndex].singleAmount = 1;
          this.libaoList[this.currtIndex].assetsId = item.assetsId;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "0") {
                ele.assetsId = item.couponId;
                ele.price = item.discount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = 1;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.name}`;
                ele.quota = item.quota;
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "1") {
          // 、、 东券
          let params = {
            assetsId: item.couponId,
            price: item.discount,
            prizeType: item.prizeType,
            singleAmount: 1,
            totalAmount: this.ruleForm.sendCount,
            title: `${item.name}`,
            quota: item.quota,
          };
          this.libaoList[this.currtIndex].priceName = item.discount + "元优惠券";
          this.libaoList[this.currtIndex].singleAmount = 1;
          this.libaoList[this.currtIndex].assetsId = item.assetsId;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "1") {
                ele.assetsId = item.couponId;
                ele.price = item.discount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = 1;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.name}`;
                ele.quota = item.quota;
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "6") {
          // 、、 积分
          let params = {
            price: item.point,
            prizeType: item.prizeType,
            singleAmount: item.point,
            totalAmount: this.ruleForm.sendCount,
            title: `${item.point}积分`,
          };
          this.libaoList[this.currtIndex].priceName = "每份店铺积分：" + item.point;
          this.libaoList[this.currtIndex].singleAmount = item.point;
          // this.libaoList[this.currtIndex].assetsId = item.activityName.value;
          // const num = this.ruleForm.prizes.indexOf(item.priceType);
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "6") {
                // ele.assetsId = item.activityName.value
                ele.price = item.point;
                ele.prizeType = item.prizeType;
                ele.singleAmount = item.point;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.point}积分`;
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        } else if (item.prizeType == "4") {
          // 、、 京豆
          let params = {
            assetsId: item.activityName.value,
            price: item.singleAmount,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount,
            totalAmount: this.ruleForm.sendCount,
            title: `${item.singleAmount}京豆`,
            quantityTotal: item.quantityTotal,
          };
          this.libaoList[this.currtIndex].priceName = "每份京豆额：" + item.singleAmount;
          this.libaoList[this.currtIndex].singleAmount = item.singleAmount;
          this.libaoList[this.currtIndex].assetsId = item.activityName.value;
          // 判断是否选中
          if (this.libaoItem.backAction == true) {
            this.ruleForm.prizes.forEach((ele) => {
              if (ele.prizeType == "4") {
                ele.assetsId = item.activityName.value;
                ele.price = item.singleAmount;
                ele.prizeType = item.prizeType;
                ele.singleAmount = item.singleAmount;
                ele.totalAmount = this.ruleForm.sendCount;
                ele.title = `${item.singleAmount}京豆`;
                ele.quantityTotal = item.quantityTotal;
              }
            });
          } else {
            this.ruleForm.prizes.push(params);
          }
          this.libaoList[this.currtIndex].backAction = true;
        }
      }
      console.log(this.ruleForm.prizes);
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputnsend(e, data = "", type = "nojindou") {
      if (type == "nojindou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // //下边写用户输入时需要的执行逻辑
        // if(this.ruleForm.inputprize!= filtered) {
        //     this.ruleForm.inputprize = filtered
        // }
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        let quantityTotal = 0;
        let price = 0;
        this.ruleForm.prizes.forEach((ele) => {
          if (ele.prizeType == "4") {
            price = ele.price;
            quantityTotal = ele.quantityTotal;
          }
        });
        console.log(data, e, quantityTotal, price, 555);
        if (quantityTotal && price && data) {
          let numTotal = this.$jingdouTotal({ price: price, quantityTotal: quantityTotal, prizeCount: data });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return data;
        }
      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },
    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
        this.mainImagelist = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    //重新选择模板
    handleChoice(item) {
      // console.log(item,this.giftPopupNum, 2222);
      if (item) {
        if (item.giftPrizeType == 0) {
          if (this.giftPopupNum == 2) {
            this.memberGiftTemplateId = item.id;
            this.templateUrlimg1 = item.templateUrl;
          } else {
            this.giftID = item.id;
            this.templateUrlimg = item.templateUrl;
          }
        } else {
          this.giftID = item.id;
          this.templateUrlimg = item.templateUrl;
        }

        this.nextStepKai(item, "2");
      }

      this.giftPopup = false;
    },
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1)
    },
  },
};
</script>

<style lang="scss" scoped>
.add_btn1 {
  cursor: pointer;
  color: #2670FB;
  border: 1px solid #2670FB;
  width: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(123,97,255,0.1);
  border-radius: 4px;
  margin-top: 8px;
}

.addBox{
  background: url('../../assets/thdImg/pages/add.svg') 0 center no-repeat;
  padding-left: 22px;
  color:#2670FB;
}

.privacyWarningTitele {
  width: 580px;
  height: 42px;
  background: #FDF6EC;
  border-radius: 4px;
  line-height: 42px;
  display: block;
  padding-left: 15px;
  margin: 10px 0 6px;
}

.privacyContent {
  width: 500px;
  position: relative;

  .prosi {
    position: absolute;
    bottom: 6px;
    right: 20px;
  }
}

.warningTitele{
  width: 952px;
  height: 42px;
  background: #FDF6EC;
  border-radius: 4px;
  line-height: 42px;
  display: block;
  padding-left: 15px;
  margin: 10px 0 6px -109px;
}
.navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      span {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #fe4d45;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #fe4d45;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
        @keyframes opation {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 100%;
          }
        }
      }
    }
.overHiddle{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 2px;
  width: 96%;
  border: none;
  text-align: left;
  display: inline-block;
  margin-left: -8px;
  &:hover,&:focus{
    color: #666;
    background: #fff;
  }
}
.orangeColor {
  color: #fe4d45;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #F4F8FF;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
//
.wrapperBg {
  // background: url("../../assets/images/integralCenter/tcdt.png") no-repeat;
  background-color: #666 !important;
}
.giftBottom{
  position: absolute;
    bottom: 19%;
    left: 50%;
    transform: translateX(-50%);
    // background: red;
    width: 112px;
    height: 24px;
    display: block;
    text-align: center;
    line-height: 24px;
    color: red;
    opacity: 0.7;
    font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.shopSet {
  width: 880px;
  display: flex;
  &-left {
    width: 100%;
    .shopSetLeft-connet {
      width: 580px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .inner {
        margin-top: 20px;
        width: 275px;
        height: 150px;
        background: #ffffff;
        border: 1px solid #f5f5f5;
        border-radius: 8px;
        cursor: pointer;
        .innerTap {
          width: 100%;
          height: 50px;
          line-height: 50px;
          padding: 0 12px;
          background: #f5f5f5;
          border-radius: 8px 8px 0px 0px;
          position: relative;
          .logoImg {
            position: absolute;
            top: 17px;
            width: 16px;
            height: 16px;
            display: inline-block;
          }
          .img0 {
            background: url("../../assets/images/integralCenter/zu6828.svg") no-repeat;
          }
          .img1 {
            background: url("../../assets/images/integralCenter/zu6829.svg") no-repeat;
          }
          .img2 {
            background: url("../../assets/images/integralCenter/zu6826.svg") no-repeat;
          }
          .img3 {
            background: url("../../assets/images/integralCenter/zu6827.svg") no-repeat;
          }
          .innerTap-name {
            display: inline-block;
            width: 186px;
            height: 26px;
            line-height: 26px;
            padding-left: 19px;
          }
          .innerTap-bottom {
            display: inline-block;
            width: 60px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background: #d5d8de;
            border-radius: 4px;
            color: #fff;
          }
        }
        .innerTip {
          width: 100%;
          height: 100px;
          line-height: 100px;
          text-align: center;
          font-size: 20px;
          font-weight: 500;
          color: #333333;
        }
        &:hover {
          border: 1px solid #fe4d45;
          box-shadow: 0px 6px 16px rgba(160, 26, 20, 0.15);
          border-radius: 9px;
          .innerTap {
            background: #fe4d45 !important;
            color: #fff;
            .img0 {
              background: url("../../assets/images/integralCenter/zu12.svg") no-repeat;
            }
            .img1 {
              background: url("../../assets/images/integralCenter/zu13.svg") no-repeat;
            }
            .img2 {
              background: url("../../assets/images/integralCenter/zu14.svg") no-repeat;
            }
            .img3 {
              background: url("../../assets/images/integralCenter/zu15.svg") no-repeat;
            }
            .innerTap-bottom {
              background: #fff;
              color: #fe4d45;
            }
          }
        }
      }
      .innerAction {
        border: 1px solid #fe4d45;
        box-shadow: 0px 6px 16px rgba(160, 26, 20, 0.15);
        border-radius: 9px;
        .innerTapAction {
          background: #fe4d45;
          color: #fff;
          .imgAction0 {
            background: url("../../assets/images/integralCenter/zu12.svg") no-repeat;
          }
          .imgAction1 {
            background: url("../../assets/images/integralCenter/zu13.svg") no-repeat;
          }
          .imgAction2 {
            background: url("../../assets/images/integralCenter/zu14.svg") no-repeat;
          }
          .imgAction3 {
            background: url("../../assets/images/integralCenter/zu15.svg") no-repeat;
          }
          .botAction {
            background: #fff;
            color: #fe4d45;
          }
        }
      }
    }
  }
  &-right {
    // padding-top: 20px;
    margin-top: -5px;
    margin-left: 100px;
    width: 235px;
  }
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #75baff;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #75baff;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #fe4d45;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign{
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 45px;
  right: 20px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}


.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #2670FB;
    border: 1px solid #2670FB;
    background:rgba(38, 112, 251, 0.1);
    width: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    border-radius: 4px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  // min-width: 1360px;
  position: relative;
  box-sizing: border-box;
  // min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
      margin-left: 11%;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding:14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width:100%;
        flex:1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width:100%;
          height: 100%;
          display:grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #fe4d45;
                border-bottom: 1px solid #fe4d45;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #fe4d45;
                border-left: 1px solid #fe4d45;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            
          }
          .lijijq{
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              font-family: system-ui;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
            .borderkaika::before,
            .borderkaika::after {
              opacity: 1;
              transform: scale(1);
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color:#fff;
                // opacity: 0.7;
              }
            }
          }
          .borderkaika {
            position: absolute;
            left: -6px;
            top: -6px;
            width: 104%;
            height: 104%;
            border-radius: 4px;
            &::before,
            &::after {
              position: absolute;
              top: -2%;
              right: 0;
              bottom: 0;
              left: -2%;
              content: "";
              opacity: 0;
              pointer-events: none;
              transition: opacity 0.8s, transform 0.8s;
              border-radius: 4px;
            }
            &::before {
              border-top: 1px solid #fe4d45;
              border-bottom: 1px solid #fe4d45;
              -webkit-transform: scale(0, 1);
              transform: scale(0, 1);
            }
            &::after {
              border-right: 1px solid #fe4d45;
              border-left: 1px solid #fe4d45;
              -webkit-transform: scale(1, 0);
              transform: scale(1, 0);
            }
          }
        }
      }
    }
  }

  .secondstep {
    // min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38,112,251,0.1000);
      border: 1px solid #2670FB;
      color: #2670FB;
      border-radius: 4px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      height: 142px;
      width: 302px;
      .theBox {
        height: 142px;
        width: 302px;
        // border: 1px solid #999;
        background: url('../../assets/thdImg/pages/yhq.svg') no-repeat;
        border-radius: 8px;
        position: absolute;
        color: #333333;
        margin-bottom: 10px;
        .discount_sty {
          font-family: DIN;
          font-weight: bold;
          color: #2670fb;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 100%;
          height: 100%;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
  }
    

.margin-left-8 {
  margin-left: 8px;
}
.margin-left-12 {
  margin-left: 12px;
  i {
    cursor: pointer;
    color: #ccc;
  }
}
.tips-style {
  color: #cccccc;
}
  .wrapper-kaika-img{
    width:210px;height: 374px;margin-bottom:40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika{
     grid-template-columns: repeat(4, 1fr) ; 
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika{
     grid-template-columns: repeat(5, 1fr) ; 
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika{
     grid-template-columns: repeat(6, 1fr) ; 
  }
}
@media (min-width: 1900px){
  .wrapper-kaika{
     grid-template-columns: repeat(7, 1fr) ; 
  }
}

</style>



